// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
    max-width: 100%;
}

ul {
    padding: 0px;
    margin: 0px;
    list-style: none;
}

a {
    text-decoration: none;
}

body {
    background-color: #121212;
}

.usd_future_dashboard {
    width: 100%;
    display: block;
    background-color: #121212;
    height: 100%;
    color: #fff;
    padding: 0px 10px;
}

.top_bar_usd_future {
    width: 100%;
    gap: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}


.dashboard_mid_s .order_trade_s .futurestbllft .table_info_data table tr td {
    min-width: 100px;
}

.usd_left_pr {
    display: flex;
    align-items: center;
    gap: 15px;
    width: 290px;
}

.top_future_left_s ul li:nth-child(5) {
    min-width: 150px;
}

.top_future_left_s ul li:nth-child(4) {
    min-width: 130px;
}

.top_future_left_s ul li:nth-child(3) {
    min-width: 110px;
}

.market_price_list_top {
    width: 73%;
}

.price_top_right {
    min-width: 130px;
    font-size: 16px;
    color: #01BC8D;
    font-weight: 500;
    line-height: 19px;
    display: flex;
    flex-direction: column;
    white-space: nowrap;
}

.currency_popup_s .search_form input {
    padding: 5px 15px;
    color: #fff;
}

.no-data {
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    color: #fff;
    /* width: 100%; */
}

.price_top_right span {
    font-size: 14px;
    font-weight: 400;
}

.btcusd__currency span {
    width: 18px;
    height: 18px;
    border: 1px solid #434343;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
}

.btcusd__currency {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
}

.top_future_left_s {
    display: flex;
    align-items: center;
    gap: 18px;
    width: 75%;
    justify-content: start;
}

.top_future_left_s ul {
    display: flex;
    align-items: center;
    gap: 22px;
    padding: 0px;
    margin: 0px;
    list-style: none;
}

.top_future_left_s ul li span {
    color: #6C6C6C;
}

.top_future_left_s ul li {
    font-size: 12px;
    white-space: nowrap;
    width: -moz-fit-content;
    width: fit-content;
}

.top_future_left_s ul li span.yellow {
    color: hsl(33, 97%, 58%);
}

.top_future_right_s {
    text-align: right;
    width: 25%;
}

.top_future_right_s ul {
    padding: 0px;
    margin: 0px;
    list-style: none;
    display: flex;
    align-items: center;
    gap: 16px;
}

.top_future_right_s ul li {
    color: #c3c3c3;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    padding-right: 12px;
    border-right: 1px solid #222222;
    line-height: 10px;
    cursor: pointer;
}

.success-color {
    color: #01bc8d;
}

.danger-color {
    color: #f75455;
}


.top_future_right_s ul li:last-child {
    border: none;
}

.dashboard_mid_s {
    width: 100%;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    margin-top: 8px;
}

.dashboard_mid_s .dashboard_summary_lft {
    width: 60%;
    padding: 5px 10px;
    background: #181A20;
    overflow: hidden;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    position: relative;
    color: #fffffff2;
}

.dashboard_mid_s .dashboard_summary_lft img {
    width: 100%;
}

.order_trade_s {
    width: 16%;
    padding: 0px;
    background: #181A20;
    overflow: hidden;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    position: relative;
    color: #fffffff2;
}

.dashboard_mid_s.space_gap_0 .trade_movers_tb ul.nav-tabs-check {
    border-bottom-color: #ffffff12;
}

.dashboard_mid_s.space_gap_0 .trade_movers_tb button.nav-link-check {
    font-size: 13px;
    color: #ffffffd1;
    padding: 9px 15px;
}

.dashboard_mid_s.space_gap_0 .order_trade_s .table-trade {
    padding: 0px 10px;
}

.dashboard_mid_s.space_gap_0 .relative_select_right {
    background-color: transparent;
}


.dashboard_mid_s .order_trade_s .table_info_data table tr th {
    padding: 3px 0px !important;
    font-size: 12px;
    font-weight: 300;
    color: #87909F;
    position: sticky;
    top: 0;
    z-index: 5;
    background-color: #181a20 !important;
}

.dashboard_mid_s .order_trade_s .table_info_data table tr td {
    font-size: 12px;
    padding: 3px 0px !important;
    font-weight: 200;
}

.dashboard_mid_s.space_gap_0 .trade_movers_tb button.nav-link-check.active {
    background-color: #1b1b1b00;
    color: #01BC8D;
}

.order_trade_s .buy_sell_row {
    border-bottom: none;
    margin-bottom: 0px;
    padding: 10px 0px 0px;
}

/* Order Book / Recent Trades tabs - active state without reload */
.order_trade_s .trade_movers_tb ul.nav-tabs .nav-item .nav-link {
    color: #949AA4;
    border: none;
    border-bottom: 2px solid transparent;
    background: transparent;
}

.order_trade_s .trade_movers_tb ul.nav-tabs .nav-item.active .nav-link,
.order_trade_s .trade_movers_tb ul.nav-tabs .nav-item .nav-link.active {
    color: #fff;
    border-bottom-color: #fff !important;
    font-weight: 500;
}

.top_hd_s {
    background-color: #121212;
    border-radius: 8px 8px 0px 0px;
    padding-right: 20px;
    position: relative;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.order_book_info {
    width: 100%;
}

.toggle_dotted {
    width: 10px;
    cursor: pointer;
}

.orderbook_lightbox .form-check {
    font-size: 14px;
}

.orderbook_lightbox {
    color: #fff;
}

.orderbook_lightbox {
    width: 250px;
    display: none;
    position: absolute;
    top: 30px;
    right: 0px;
    z-index: 666;
    background-color: #3c3c3c;
    padding: 24px;
    border-radius: 10px;
    border: 1px solid #494949;
}

.orderbook_lightbox.active {
    display: block;
}

.orderbook_lightbox h6 {
    font-size: 13px;
    font-weight: 400;
    padding-bottom: 10px;
}

.orderbook_lightbox .d-flex.gap-3 {
    flex-direction: column;
}

.top_hd_s h2 {
    font-size: 15px;
    margin: 0px;
    background-color: #1B1B1B;
    padding: 6px 15px;
    font-weight: 400;
}

.order_top_table_grid {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 10px 0px;
}

.order_top_table_grid ul.togglebtn {
    display: flex;
    gap: 12px;
}

.order_top_table_grid ul.togglebtn li {
    border: 1px solid #3B3B3B;
    border-radius: 3px;
    display: flex;
    padding: 1px 3px;
    align-items: center;
    justify-content: center;
}

.order_right_toggle ul {
    display: flex;
    gap: 15px;
}

.order_right_toggle ul li {
    font-size: 12px;
    color: #787878;
}

.table_info_data table {
    font-size: 12px;
    width: 100%;
}

.table_info_data table tr th {
    padding: 4px 10px;
    color: #636363;
    font-weight: 400;
}

.table_info_data table tr td {
    padding: 5px 10px;
    color: #e9e9e9;
}

.table_info_data table tr td.danger {
    color: #F65454;
}

.table_info_data table tr.totaltb td.danger {
    font-size: 18px;
}

.table_info_data table tr.totaltb td.sucess {
    font-size: 18px;
}

.table_info_data table tr .subtotal {
    text-align: center;
    color: #999;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.table_info_data table tr td.sucess {
    color: #01BC8D;
}

.table_info_data table tr .subtotal span {
    border: 2px solid #3B3B3B;
    border-radius: 3px;
    margin-right: 5px;
    font-weight: 700;
    color: #666666;
    font-size: 10px;
    padding: 1px 2px;
    /* align-items: center; */
    justify-content: center;
}

.trade_movers_tb ul.nav-tabs-check {
    gap: 18px;
}

.currency_popup_s .search_form {
    display: flex;
    gap: 0px;
}

.currency_data_list table tr td p {
    font-size: 14px;
}

.trade_movers_tb button.nav-link-check.active {
    background-color: #1b1b1b29;
    border: none;
    color: #fff;
}

.trade_movers_tb button.nav-link-check {
    font-size: 14px;
    margin: 0px;
    color: #fff;
    border: none;
    padding: 6px 0px;
    font-weight: 400;
    background-color: transparent;
}

.trade_movers_tb button.nav-link-check:hover {
    background-color: transparent !important;
}

.trade_movers_tb button {
    background-color: transparent !important;
}

.trade_movers_tb button.nav-link-check:hover {
    border: none;
    outline: none;
}

.trade_summary_table_lft .tab-content>.tab-pane.show {
    display: block;
}

.trade_movers_tb .tab-content>.tab-pane.show {
    display: block;
}

.market_spot_form .tab-content>.tab-pane.show {
    display: block;
}

.trade_summary_table_lft .nav-tabs-check li.active button.nav-link-check {
    background-color: #1B1B1B;
    color: #fff;
}

.tab-pane.fade.showactive {
    display: block;
    opacity: 1;
}

.modal.currency_popup_s .modal-dialog .modal-content {
    background-color: #2b313c;
    border: 1px solid #2b313c;
    border-radius: 12px;
}



.modal.currency_popup_s .currency_data_list table tr td {
    font-size: 11px;
    padding: 8px 0px;
    color: #ffffff;
}

.modal.currency_popup_s .search_form {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0 12px;
}

.modal.currency_popup_s .bn-tabs_favorites_bl button#usd-tab {
    color: #fff;
    background-color: transparent;
    border: none;
}

.modal.currency_popup_s .currency_data_list table tr th {
    font-size: 11px;
    padding: 11px 0px !important;
    color: #a7a7a7;
}

.modal.currency_popup_s .modal-header {
    border: none !important;
}

.modal.currency_popup_s .currency_data_list table h6 {
    font-size: 12px;
}

.modal.currency_popup_s .currency_data_list table tr td p {
    font-size: 12px;
}

.relative_select_right {
    width: 20%;
    min-height: 100%;
    max-height: 640px;
    overflow: auto;
    padding: 10px 18px;
    background-color: #181A20 !important;
    border: none;
    border-radius: 0px;
    position: relative;
    color: #fffffff2;
}

.top_cross_dashboard {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0px;
}

.copy_icon {
    max-width: 15px;
}

.spot_future_ {
    width: 100%;
    background-color: #121212;
    padding: 0px 15px;
    margin-top: 7px;
}

.spot_future_ ul {
    display: flex;
    gap: 10px;
}

.spot_future_ ul li a {
    color: #999;
    font-size: 13px;
    text-decoration: none;
    border-bottom: 1px solid #121212;
    display: block;
    padding: 10px 4px;
    font-weight: 500;
}

.spot_future_ ul li span {
    color: #01BC8D;
    background-color: #102621;
    padding: 4px;
    border-radius: 5px;
}

.spot_future_ ul li.active a {
    color: #fff;
    border-bottom: 1px solid #01BC8D;
}

.leverage_bl {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0px 10px;
    gap: 12px;
}

.leverage_bl>div {
    background-color: #1B1B1B;
    border-radius: 8px;
    width: 80%;
    gap: 14px;
    font-size: 12px;
    font-weight: 500;
    padding: 8px 20px;
    align-items: center;
    display: flex;
    justify-content: center;
}

.leverage_bl .rage_txt {
    color: #5F5F5F;
}

.leverage_bl div.plustext {
    width: auto;
    padding: 8px 6px;
}

.market_spot_form {
    width: 100%;
    margin-top: 7px;
}

.market_spot_form .nav-tabs-check {
    background-color: #121212;
    border: none;
    justify-content: start;
    margin-bottom: 10px;
}

.market_spot_form .nav-tabs-check li button {
    border: none;
    background-color: transparent !important;
    color: #6C6C6C !important;
    font-size: 13px;
    font-weight: 500;
    padding: 5px 6px !important;
    border-bottom: 1px solid #111114 !important;
}

.market_spot_form .nav-tabs-check li button.active {
    color: #fff !important;
    color: #fff !important;
    border-bottom: 1px solid #f3bb2b !important;
}

.market_spot_form .nav-tabs-check li a {
    border: none;
    background-color: transparent !important;
    color: #6C6C6C !important;
    font-size: 13px;
    font-weight: 500;
}

.market_spot_form .nav-tabs-check li a.active {
    color: #fff !important;
}

.market_spot_form .nav-tabs-check li .dropdown-menu li a {
    color: #000 !important;
}

form.price_info {
    min-height: 100px;
    max-height: 100%;
    /* overflow: scroll; */
    width: 100%;
    padding: 0px 0px 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.price_inputbl {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.price_inputbl label {
    font-size: 12px;
    color: #6C6C6C;
    font-weight: 400;
}

.price_select_option {
    background-color: transparent;
    font-size: 12px;
    border-radius: 50px;
    gap: 10px;
    padding: 8px 15px;
    display: flex;
    justify-content: space-between;
    border: 1px solid rgb(255 255 255 / 10%);
}

.price_inputbl .inputtype {
    border: none;
    background-color: transparent;
    padding-left: 2px;
    color: #fff;
    width: 100%;
    max-width: 100%;
}

.price_inputbl select {
    border: none;
    background-color: transparent;
    color: #e1e1e1;
    font-size: 13px;
    width: 100px;
}

select:focus-visible {
    outline: none;
}

.price_inputbl label span {
    color: #ababab;
}

.price_inputbl ul {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: space-between;
}

.price_inputbl ul li button {
    font-size: 12px;
    border-radius: 3px;
    width: 100%;
    text-align: center;
    background-color: #2A2A2A;
    color: #ababab;
    padding: 5px;
    border: none;
}

.avail_total_usd {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}

.tpsl_reduce {
    flex-direction: column;
    font-size: 13px;
    color: #6C6C6C;
}

.buysell_btn button {
    padding: 6px 26px;
    background-color: #01BC8D;
    border: none;
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    border-radius: 50px;
    width: 50%;
}

.buysell_btn button.sellbtn {
    background-color: #F65454;
}

.buy_transferbtn button {
    font-size: 14px;
    padding: 7px 26px;
    border-radius: 50px;
    border: none;
}

.costbtc_total h5 {
    font-size: 12px;
    color: #767676;
    margin: 0px;
}

.costbtc_total h5 span {
    color: #fff;
}

.price_inputbl .inputtype:focus-visible {
    outline: none;
}

.trade_account_summary_assets {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 1px;
    gap: 4px;
}

.trade_account_summary_assets {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: #121212;
}

.trade_summary_table_lft {
    width: 100%;
    max-width: 100%;
    padding: 10px 0px;
    background: #181A20;
    border: none;
    border-radius: 0px;
    position: relative;
    color: #fffffff2;
    font-family: "Inter", sans-serif;
    margin-bottom: 0px;
}

.trade-wrapper.spot {
    font-family: "Inter", sans-serif;
}

.trade_summary_table_lft .nav-tabs-check {
    border-bottom: 1px solid #282828;
    gap: 15px;
}

.trade_summary_table_lft .nav-tabs-check li button {
    border-radius: 0px;
    border: none;
    background-color: transparent;
    font-size: 13px;
    font-weight: 400;
    padding: 5px 10px;
    color: #9f9f9f;
}

.trade_summary_table_lft .nav-tabs-check li button.active {
    background-color: #1B1B1B;
    color: #fff;
    /* border-bottom: 1px solid #282828; */
}

.trade_summary_table_lft .tab-content {
    min-height: 260px;
    display: flex;
    align-items: start;
    justify-content: center;
}

.trade_summary_table_lft .tab-content h4 {
    font-size: 14px;
    margin: 0px;
}

.trade_summary_table_lft .table-responsive {
    display: flex;
    justify-content: center;
    align-items: start;
    width: 100%;
    min-height: 400px;
    flex-wrap: wrap;
}

.order_trade_s .tab-content.mt-2 {
    height: 89%;
}

.trade_summary_table_lft p.text-center.no-data.h-100.mb-0.center_b {
    padding: 0px 0px 0px;
}

.order_trade_s .favouriteData {
    padding: 0px;
}

.assets_right {
    width: 396px;
    max-width: 100%;
    background-color: transparent;
    padding: 10px 18px;
    position: relative;
    color: #fffffff2;
}

.asset_total_value {
    padding: 0px;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.asset_total_value h5 {
    color: #fff;
    font-weight: 500;
}

.asset_total_value div {
    font-size: 12px;
}

.asset_total_value div h6 {
    font-size: 12px;
    margin: 0px;
    color: #767676;
}

.danger {
    color: #F65454;
}

span.green {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #01BC8D;
}

.buy_transferbtn {
    gap: 8px;
    margin: 10px 0px 30px;
}

.buy_transferbtn a {
    font-size: 12px;
    background-color: #2B313C;
    color: #fff;
    border: none;
    padding: 7px 18px;
    width: 100%;
    border-radius: 50px;
    text-align: center;
}

.top_future_right_s ul li img {
    min-width: 20px;
}

.futuresflex .assets_right {
    width: 24.23%;
}

.search_form {
    width: 100%;
    border: 1px solid #c7c7c7;
    padding: 5px;
    border-radius: 5px;
    gap: 10px;
}

.search_form input {
    border: none;
    width: 100%;
}

.search_form input:focus-visible {
    outline: none;
}

.bn-tabs_favorites_bl button.nav-link-check {
    border: none;
    padding: 0px;
    font-size: 14px;
    font-weight: 500;
    color: #626262;
    line-height: 22px;
}

.bn-tabs_favorites_bl li a {
    border: none;
    padding: 0px;
    font-size: 14px;
    font-weight: 500;
    color: #626262;
    line-height: 22px;
}

.bn-tabs_favorites_bl li a:focus {
    border: none;
}

.bn-tabs_favorites_bl li a:hover {
    border: none;
}

.bn-tabs_favorites_bl li a.active {
    border: none;
}

.bn-tabs_favorites_bl ul {
    border: none;
    margin: 10px 0px;
}

.modal.currency_popup_s .modal-dialog {
    max-width: 620px;
    min-width: 600px;
}

.currency_data_list {
    color: #181818;
}

.currency_data_list table {
    width: 100%;
}

.currency_data_list table tr td {
    font-size: 14px;
    padding: 8px 0px;
}

.currency_data_list table tr th {
    font-size: 14px;
    padding: 5px 0px;
    font-weight: 400;
}

.currency_data_list table h6 {
    margin: 0px;
    font-size: 14px;
}

.currency_data_list table p {
    margin: 0px;
}

.cnt_first_t {
    display: flex;
    gap: 8px;
    align-items: center;
}

.cnt_first_t .icon_currency {
    display: flex;
    gap: 5px;
    align-items: center;
}

.cnt_first_t .icon_currency img {
    /* width: 32px; */
}

.cnt_first_t .icon_currency svg {
    width: 20px;
    height: auto;
}

.no_data_found {
    width: 100%;
    display: block;
    text-align: center;
    padding: 70px 0px;
    color: #000;
}

.no_data_found svg {
    width: 100px;
}

.no_data_found svg path {
    fill: #000;
}

.top_future_left_s ul li.dropdown ul.dropdown-menu {
    display: none;
}

.top_future_left_s ul li.dropdown ul.dropdown-menu.dropdown-menu.show {
    display: flex;
    flex-direction: column;
    gap: 9px;
    align-items: normal;
    padding: 10px;
}


.top_tabs_center {
    display: flex;
    justify-content: space-between;
    position: relative;
    color: #222;
    font-size: 13px;
    font-weight: 500;
    align-items: center;
}

.classic_option_top {
    width: 100%;
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 5px;
}

.leftbar_classic {
    width: auto;
}

.leftbar_classic ul {
    display: flex;
    align-items: center;
    gap: 7px;
}

.leftbar_classic ul li a {
    width: 40px;
    height: 46px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #121212;
}

.leftbar_classic ul li a:hover {
    background-color: #2A2310;
}

.leftbar_classic ul li rect {
    fill: #fff;
}

.leftbar_classic ul li.active a {
    background-color: #2A2310;
}

.leftbar_classic ul li.active rect {
    fill: #FEBA00;
}

.classic_usd_right {
    width: 100%;
}

.classic_usd_right ul {
    display: flex;
    gap: 40px;
}

.classic_usd_right ul li {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #a2a2a2;
    gap: 10px;
    padding: 6px 10px;
    border-radius: 7px;
}

.classic_usd_right ul li:first-child {
    background-color: #444444;
    color: #fff;
}

.classic_usd_right ul li .cnt_top_cl h6 {
    margin: 0px;
    font-size: 13px;
}

.classic_usd_right ul li .cnt_top_cl p span {
    padding-left: 20px;
}

.classic_usd_right ul li .cnt_top_cl p {
    margin: 0px;
    font-size: 14px;
}

.classic_usd_right ul li img {
    max-width: 24px;
}

.classic_grid_dashboard_left {
    width: 100%;
}

.classic_favorites_bl {
    width: 100%;
    border-top: 1px solid #f3f3f329;
    margin: 0px;
}

.topnav_selected .nav-tabs-check {
    border: none;
}

.topnav_selected .nav-tabs-check .nav-link-check {
    padding: 0px;
    border: none;
    color: #f3f3f39c;
    padding: 5px 10px;
    font-size: 13px;
}

.topnav_selected .nav-tabs-check .nav-link-check:hover {
    border: none;
}

.topnav_selected .nav-tabs-check .nav-link-check.active {
    background-color: transparent;
    color: #fff;
}

.d-flex.topnav_selected {
    padding: 10px 0px;
    justify-content: space-between;
    align-items: center;
}

.right_top_r {
    display: flex;
    gap: 20px;
    padding-right: 32px;
    position: relative;
}

.right_top_r .form-check {
    font-size: 13px;
    color: #f3f3f39c;
    margin: 0px;
}

.right_top_r .orderbook_lightbox form .d-flex {
    flex-direction: column;
}

.displayed_reset {
    padding: 13px 0px;
}

.displayed_reset h6 {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.displayed_reset h6 span {
    color: #f0b90b;
}

.decimal_text {
    font-size: 12px;
    color: #b3b3b3;
    justify-content: space-between;
    align-items: center;
}

.decimal_text p {
    margin: 0px;
    font-size: 15px;
}

.classic_favorites_bl .col-sm-9 .tab-content {
    border-top: 1px solid #f3f3f329;
    padding: 0px !important;
}

.top_barcalls_put_cnt {
    border-bottom: 1px solid #f3f3f329;
}

.top_barcalls_put_cnt ul {
    display: flex;
    align-items: center;
    gap: 40px;
    padding: 15px 0px;
    justify-content: center;
}

.top_barcalls_put_cnt ul li {
    font-size: 13px;
    color: #c5c5c5;
}

.top_barcalls_put_cnt ul li strong {
    color: #fff;
}


.data_option_calls table tr th {
    font-size: 12px;
    font-weight: 400;
    color: #999;
    padding: 15px;
    border-bottom: 1px solid #f3f3f329;
    white-space: nowrap;
}

.data_option_calls table tr td {
    font-size: 13px;
    font-weight: 400;
    color: #999;
    padding: 15px;
    border-bottom: 1px solid #f3f3f329;
}

.data_option_calls table tr td.text-succes {
    color: #01BC8D;
}

.data_option_calls table tr td.danger {
    color: #F65454;
}

.top_table_data .mid_data tr td {
    height: 70px;
    text-align: center;
}

.data_option_calls table {
    width: 100%;
}

.recent_tables_outer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tables_calls {
    width: 100%;
}

.tables_puts {
    width: 100%;
}

.recent_trades_options table {
    width: 100%;
    font-size: 13px;
}

.recent_trades_options table tr th {
    font-size: 12px;
    font-weight: 400;
    color: #999;
    padding: 15px;
    border-bottom: 1px solid #494949;
}

.recent_trades_options table tr td {
    font-weight: 400;
    padding: 15px;
    border-bottom: 1px solid #494949;
}

#TVFuturesChartContainer iframe {
    height: 600px !important;
}

@media (max-width: 480px) {

    #TVFuturesChartContainer,
    #TVFuturesChartContainer iframe {
        height: 400px !important;
    }
}

.recent_trades_options h6 {
    font-size: 12px;
    color: #999;
    padding: 0px 15px;
}

.classic_favorites_bl .trade_summary_table_lft .nav-tabs-check li button {
    padding: 10px;
}

.classic_favorites_bl .trade_summary_table_lft {
    width: 100%;
    overflow: hidden;
}

.hide_underlying_s {
    display: flex;
    justify-content: end;
    padding-right: 30px;
    gap: 5px;
    align-items: center;
    font-size: 13px;
    color: #999;
}

.trade_summary_table_lft .row {
    align-items: center;
}

.option_account_right {
    width: 100%;
    border-left: 1px solid #f3f3f32b;
    height: 100%;
}

.trade_option_bl {
    width: 100%;
    margin: 0px;
    padding: 32px;
    background-color: #222222;
    text-align: center;
}

.classic_favorites_bl>.col-sm-9 {
    padding: 0px;
}

.classic_favorites_bl>.col-sm-3 {
    padding: 0px;
}

.option_account_right h2 {
    font-size: 15px;
}

.trade_option_bl p {
    font-size: 12px;
    margin: 0px;
    max-width: 220px;
    margin: 5px auto;
}

.option_block {
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    padding: 16px;
    background-color: #454545;
}

.option_block span {
    font-size: 12px;
}

.youtube_icon {
    max-width: 50px;
    margin: 0 auto;
    margin-top: 13px;
}

.trade_option_bl .row {
    padding-top: 20px;
}

.account_block_s {
    width: 100%;
    padding: 24px 32px;
}

.account_tabs_info {
    width: 100%;
    display: block;
    border-bottom: 1px solid #f3f3f32b;
    padding-bottom: 20px;
    margin-top: 20px;
}

.account_tabs_info h5 {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.account_tabs_info ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
    font-size: 12px;
}

.account_tabs_info .cnt_ac.hide {
    display: none;
}

.account_tabs_info ul a {
    color: #a3a3a3;
    font-size: 13px;
}


.video_popup .modal-dialog {
    max-width: 750px;
}

.video_popup .modal-content {
    background-color: #242526;
    border-radius: 24px;
    padding: 5px 12px;
}

.video_popup .btn-close {
    border-radius: 50px !important;
    background-color: #fff;
    opacity: 1;
}

.video_popup .modal-header {
    border: none;
}

.easy_option_dashboard {
    background-color: #121212;
}

.easy_mode_back {
    width: 100%;
    padding-top: 18px;
}

.easy_mode_back a {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #d9d9d99c;
}

.easy_mode_back svg {
    width: 20px;
}

.prediction_top_s {
    width: 100%;
    padding: 55px 0px;
    text-align: center;
    color: #D9D9D9;
}

.prediction_bl {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.prediction_up {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 32px;
}

.prediction_bl p a {
    color: #FEBA00;
}

.prediction_bl p {
    margin: 0px;
}

.bn_steps_step {
    width: 100%;
    position: relative;
    margin: 20px 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.bn_steps_step::before {
    width: 100%;
    height: 5px;
    position: absolute;
    content: "";
    background-color: #222222;
}

.bn_steps_step .number {
    width: 28px;
    height: 28px;
    background-color: #222;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 500;
    position: relative;
}

.prediction_detail {
    width: 100%;
    padding: 24px;
    min-height: 250px;
    border-radius: 10px;
    background-color: #222222;
    color: #fff;
}

.prediction_detail ul {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 48px;
    margin-top: 70px;
}

.prediction_detail ul.nav-tabs-check {
    margin-top: 28px;
    border: none;
    justify-content: start;
    gap: 20px;
}

.prediction_detail ul li {
    cursor: pointer;
}

.prediction_detail ul.nav-tabs-check li button {
    padding: 0px;
    background-color: transparent;
    border: none;
    font-size: 14px;
    color: #D9D9D9;
    font-weight: 500;
}

.prediction_detail ul.nav-tabs-check li button.active {
    background-color: transparent;
    color: #FEBA00;
}

.prediction_detail ul.nav-tabs-check li button:focus-visible {
    box-shadow: none;
}

.prediction_detail .tab-content .tab-pane {
    margin-top: 22px;
}

.trade_summary_table_lft tr th {
    font-size: 12px;
    font-weight: 300;
    color: #999;
    padding: 8px 15px;
    white-space: nowrap;
}

.trade_summary_table_lft tr td {
    font-size: 12px;
    font-weight: 300;
    color: #dfdfdf;
    padding: 8px 12px;
}

.trade_summary_table_lft tr td .fulltbl {
    display: flex;
    gap: 5px;
    font-size: 10px;
}

.trade_summary_table_lft tr td .fulltbl span.subtxt {
    background-color: #222222;
    padding: 1px 4px;
    border-radius: 2px;
}

.trade_summary_table_lft tr th.yellowcolor {
    color: #f3bb2b;
}

.trade_summary_table_lft tr td .mkt {
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    gap: 12px;
    justify-content: space-between;
}

.trade_summary_table_lft tr td .pnl {
    border: 1px solid #2c2c2c;
    padding: 3px 10px;
    border-radius: 5px;
}

.trade_summary_table_lft tr td .reverse {
    background-color: #2c2c2c;
    padding: 4px 8px;
    border-radius: 4px;
    text-align: center;
}

.trade_summary_table_lft tr td button {
    background-color: #2c2c2c;
    border-color: #2c2c2c;
    padding: 4px 8px;
    border-radius: 4px;
    text-align: center;
    border: none;
    font-size: 12px !important;
    color: #dfdfdf;
    font-weight: 400;
}

.trade_summary_table_lft tr td .mkt ul {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #f3bb2b;
}

.trade_summary_table_lft table {
    width: 100%;
}

.trade_summary_table_lft .tab-content>.tab-pane {
    width: 100%;
}

.trade_summary_table_lft tr td.greencolor {
    color: green;
}

.trade_summary_table_lft tr td span.time {
    display: block;
}

.trade_summary_table_lft tr td i {
    color: #999;
    padding-left: 4px;
}

.trade_summary_table_lft tr td.yellowcolor {
    color: #f3bb2b;
}

ul.top_list {
    display: flex;
    padding: 6px 10px;
    gap: 6px;
}

ul.top_list li {
    font-size: 12px;
    padding: 4px 8px;
    cursor: pointer;
    color: #bfbfbf;
    border-radius: 4px;
}

ul.top_list li.active {
    background-color: #1b1b1b;
}

.fill_cnt {
    width: 100%;
    display: block;
    padding: 40px 0px;
    color: #d9d9d99c;
    text-align: center;
}

.esay_option_table {
    width: 100%;
    overflow: hidden;
    padding: 0px 20px;
}

.trade_summary_table_lft.esay_option_table h2 {
    color: #fff;
    margin: 32px 0px;
}

.trade_summary_table_lft.esay_option_table .nav-tabs-check {
    border: none;
    padding-bottom: 10px;
}

.top_th_easyop {
    border-bottom: 1px solid #282828;
}

.esay_option_table thead {
    border-bottom: 1px solid #282828;
}

.notfound_vector {
    max-width: 190px;
    margin: 0 auto;
    margin: 60px auto;
}

.buy_sell_option {
    width: 100%;
    display: block;
    padding: 40px 0px 70px;
    color: #fff;
}

.buy_sell_option h5 {
    font-size: 20px;
    font-weight: 400;
    color: #D9D9D9;
}

.buy_sell_option .nav-tabs-check {
    border-bottom: none;
    margin-top: 32px;
}

.buy_sell_option .nav-tabs-check li button.nav-link-check {
    font-size: 16px;
    color: #848e9c;
    border-radius: 0px;
    border: none;
}

.buy_sell_option .nav-tabs-check li button.nav-link-check.active {
    background-color: #5f38074d;
    color: #e4a456;
}


.probability_option .title-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.probability_option .extra-button {
    border-radius: 16px;
    background-color: rgb(252, 213, 53);
    color: rgb(24, 26, 32);
    font-size: 13px;
    line-height: 16px;
    padding: 4px 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.probability_option .extra-button svg {
    margin-left: 4px;
    width: 15px;
}

.probability_option .title {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: rgb(234, 236, 239);
}

.probability_option {
    margin: 0px;
    min-width: 0px;
    background-color: rgb(43, 49, 57);
    padding: 16px;
    border-radius: 8px;
    cursor: pointer;
    flex-basis: 100%;
    border: 1px solid transparent;
}

.probability_option ul {
    display: flex;
    justify-content: space-between;
    gap: 5px;
    flex-direction: column;
    margin-top: 12px;
}

.probability_option ul li {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    gap: 12px;
    color: #969696;
    align-items: start;
}

.probability_option ul li .value {
    font-size: 14px;
    width: 50%;
    font-weight: 500;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: end;
}

.probability_option ul li .value:first-child {
    align-items: start;
}

.buy_sell_option .tab-content {
    margin-top: 24px;
}

.probability_option:hover {
    border: 1px solid #fcd535;
}

.prediction_up img.prediction_vector {
    min-height: 170px;
}

.algo_orders_outers .nav-tabs-check {
    border-bottom: none;
}

.algo_orders_outers .nav-tabs-check li .nav-link-check {
    font-size: 16px;
    color: #d9d9d9c9;
    border: none;
    border-radius: 0px;
}

.algo_orders_outers .nav-tabs-check li .nav-link-check.active {
    background-color: transparent;
    color: #fff;
}

.topbar_order {
    justify-content: space-between;
    gap: 32px;
    align-items: center;
    padding: 7px 20px 7px 0px;
}

.portal_chat_top {
    width: 50%;
}

.portal_chat_top ul {
    display: flex;
    justify-content: end;
    gap: 30px;
    color: #fff;
}

.portal_chat_top ul li a {
    display: flex;
    gap: 10px;
    color: #fff;
    font-size: 16px;
    align-items: center;
}

.algo_detail_summary {
    width: 100%;
    padding: 24px 15px 15px;
    color: #fff;
}

.algo_detail_summary p {
    color: #d9d9d9c9;
}

.orders_leftside {
    width: 100%;
}

.orders_leftside h2 {
    font-size: 32px;
}

.orders_leftside .nav-tabs-check {
    width: 100%;
    overflow: hidden;
    background-color: #222222;
    border-radius: 10px;
    margin: 20px 0px;
}

.orders_leftside .nav-tabs-check li {
    width: 50%;
    text-align: center;
}

.algo_detail_summary .row {
    margin-top: 24px;
}

.algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check {
    width: 100%;
    padding: 22px 15px;
    border-radius: 10px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check.active {
    background-color: #25B070;
}

.algo_orders_outers .orders_leftside .nav-tabs-check li.buytab .nav-link-check img {
    transform: rotate(-90deg);
}


.amount_info_del {
    width: 100%;
    background-color: #222222;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
}

.algo_detail_summary_left {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.algo_detail_summary_left h5 {
    color: #C1C9D5;
    font-weight: 400;
    margin: 0px;
}

.pricebtn button {
    font-size: 12px;
    background-color: #FEBA00;
    border: none;
    padding: 4px 16px;
    border-radius: 4px;
    font-weight: 700;
}

.pricebtn button.blackbtn {
    background-color: #000;
    color: #fff;
}

.amount_info_del.coloum_reverse {
    flex-direction: row-reverse;
}

.price_step {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
}

.price_step::before {
    width: 100%;
    position: absolute;
    left: 0px;
    content: "";
    background-color: #5A5B5C;
    height: 5px;
    top: 38%;
}

.price_step div {
    margin-top: 40px;
    position: relative;
    font-size: 14px;
    color: #C1C9D5;
}

.price_step div button:before {
    width: 16px;
    height: 16px;
    background-color: #5A5B5C;
    position: absolute;
    right: 0px;
    top: -22px;
    content: "";
}

.placebtn button {
    width: 100%;
    background-color: #FEBA00;
    border: none;
    border-radius: 8px;
    padding: 22px 20px;
    font-size: 24px;
    font-weight: 500;
}

.price_step div button {
    padding: 0px;
    background-color: transparent;
    border: none;
    color: #fff;
}

.algo_order_right {
    width: 100%;
}

.top_right_cnt {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.left_price_summary h2 {
    font-weight: 400;
}

.left_price_summary p {
    color: #47A663;
    line-height: 15px;
    margin: 15px 0px 0px;
    display: block;
    font-weight: 500;
}

.left_price_summary p span {
    margin-left: 8px;
    background-color: #1E1E1E;
    border: 1px solid #ffffff1f;
    padding: 3px 8px;
    border-radius: 5px;
    color: #fff;
}

.morebtn_right button {
    background-color: #1E1E1E;
    border: 1px solid #ffffff1f;
    padding: 9px 16px;
    border-radius: 5px;
    color: #fff;
}

.order_summary_graphchat {
    width: 100%;
    margin-top: 40px;
}

.option_symbol_s {
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-top: 30px;
}

.options_section {
    width: 100%;
}

.options_section h6 {
    font-size: 20px;
    color: #D9D9D9;
    font-weight: 400;
}

.options_section ul {
    display: flex;
    gap: 24px;
    margin-top: 15px;
}

.options_section ul li button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 20px;
    color: #494949;
    border: 1px solid #494949;
    border-radius: 13px;
    padding: 12px 16px;
    font-weight: 600;
    background-color: transparent;
}

.options_section ul li button.active {
    color: #fff;
}

.strategies_cate ul {
    justify-content: space-between;
}

.strategies_cate ul li {
    width: 100%;
}

.strategies_cate ul li button {
    width: 100%;
}

.spot_trading_block {
    width: 822px;
    margin: 0 auto;
    max-width: 100%;
}

.d-flex.top_bar_hd {
    justify-content: space-between;
    align-items: center;
}

.d-flex.top_bar_hd h4 {
    font-size: 24px;
    font-weight: 400;
}

.setting_icon button {
    background-color: transparent;
    border: none;
}





.option_block a {
    color: #fff;
}

tr.green_light {
    background-color: #1b2a2a;
}

tr.danger_light {
    background-color: #2f1e26;
}



.section_trading .dropdown {
    position: relative;
    display: inline-block;
    width: 200px;
}

.section_trading .dropdown-toggle {
    background-color: #2F2F2F;
    color: #ffffff;
    padding: 10px 14px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border: 1px solid #444;
}

.section_trading .dropdown-toggle .left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.section_trading .dropdown-toggle img.token-icon {
    width: 24px;
    height: 24px;
}

.section_trading .dropdown-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #1c1c1c;
    border-radius: 10px;
    margin-top: 8px;
    width: 100%;
    border: 1px solid #444;
    z-index: 999;
}

.section_trading .dropdown-menu .item {
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff;
    cursor: pointer;
}

.section_trading .dropdown-menu .item:hover {
    background-color: #333;
}

.section_trading .dropdown-menu img {
    width: 22px;
    height: 22px;
}

.section_trading .dropdown-menu.show {
    display: block;
}

.d-flex.justify_currency {
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    font-size: 18px;
}

.d-flex.justify_currency p {
    color: #717A8C;
    margin: 0px;
}

.section_trading {
    background-color: #222222;
    padding: 26px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.section_trading .price {
    font-size: 26px;
    color: #717A8C;
}

.trading_info_bl {
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 12px;
    margin-top: 20px;
}

.refresh_cntr {
    width: 98px;
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0px;
    top: 33%;
    transform: translateY(-40%);
}

.total_balance {
    font-size: 18px;
    color: #717A8C;
    text-align: right;
}

.request_quote_btn button {
    font-size: 22px;
    background-color: #feba008f;
    width: 100%;
    border: none;
    border-radius: 12px;
    padding: 18px 0px 20px;
}

.request_quote_btn {
    margin-top: 10px;
}

.option_block_outer {
    width: 100%;
    color: #fff;
    padding: 20px 40px;
}

.option_block_outer h1 {
    font-size: 32px;
}

.option_block_process {
    width: 100%;
    display: block;
    padding: 20px 0px;
    border: 1px solid #575757;
    border-radius: 35px;
    padding: 40px;
    margin-top: 40px;
}

.option_block_process ul {
    display: flex;
    gap: 50px;
    justify-content: space-between;
}

.option_block_process ul li span {
    font-size: 20px;
    margin-bottom: 10px;
    display: block;
}

.option_block_process ul li h2 {
    font-size: 22px;
    font-weight: 400;
}

.option_block_process ul li p {
    color: #999999;
    margin: 0px;
}

.createblock_form {
    width: 100%;
    display: block;
    padding: 115px 0px 40px;
}

.createblock_form .nav-tabs-check {
    border: none;
}

.createblock_form .nav-tabs-check li .nav-link-check {
    font-size: 18px;
    color: #C1C9D5;
    font-weight: 600;
    border: none;
    border-radius: 12px;
}

.createblock_form .nav-tabs-check li .nav-link-check.active {
    background-color: #222222;
    color: #fff;
}

.createblock_form>.tab-content {
    margin-top: 50px;
}

.creatblock_left_inquery {
    width: 100%;
    overflow: hidden;
    border-radius: 32px;
    background-color: #474747;
}

h5.mobile {
    padding: 10px 15px 0px;
    font-size: 18px;
    display: none;
}

.createblock_form .creatblock_left_inquery .nav-tabs-check {
    border: none;
    justify-content: space-between;
    flex-direction: row;
    display: flex;
    flex-wrap: nowrap;
}

.createblock_form .creatblock_left_inquery .nav-tabs-check li {
    width: 100%;
}

.createblock_form .creatblock_left_inquery .nav-tabs-check li .nav-link-check {
    width: 100%;
    font-size: 22px;
    border-radius: 0px;
    padding: 20px 15px;
}

.creatblock_left_inquery .tab-content {
    padding: 40px;
}

.creatblock_left_inquery .form_input {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 15px;
    padding-right: 15px;
    align-items: center;
    border: 1px solid #5E5E5E;
    border-radius: 15px;
}

.creatblock_left_inquery .form_input input {
    font-size: 20px;
    width: 100%;
    color: #C1C9D5;
    background-color: transparent;
    border: none;
    padding: 15px;
}

.creatblock_left_inquery .form_input input:focus-visible {
    outline: none;
    border: none;
}

.market_spot_form .cnt_table_two {
    display: none;
}

.market_spot_form .cnt_table_two.active {
    display: block;
}

.creatblock_left_inquery .form_input select {
    background-color: transparent;
    border: none;
    font-size: 18px;
    color: #fff;
}

.creatblock_left_inquery .form_input select option {
    color: #000;
}

.creatblock_left_inquery .form_input select:focus-visible {
    outline: none;
    border: none;
}

.creatblock_left_inquery .form_input.fullsize select {
    padding: 15px;
    width: 100%;
    color: #7b7b7b;
}

.buyform form .row {
    row-gap: 32px;
}

.submitbtn button {
    font-size: 22px;
    background-color: #caab2e;
    border-radius: 15px;
    color: #000;
    padding: 18px 10px;
    border: none;
    width: 100%;
    font-weight: 600;
}

.createblock_form .submitbtn {
    background-color: transparent;
    padding: 0px;
    border-radius: 0px;
}

.markert_overview_right {
    width: 100%;
    border: 1px solid #575757;
    padding: 32px;
    border-radius: 32px;
    height: 100%;
}

.markert_overview_right ul {
    padding-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px
}

.markert_overview_right ul li {
    color: #C1C9D5;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
}

.markert_overview_right ul li:last-child {
    padding-top: 36px;
}

.strategies_form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    font-size: 20px;
    color: #494949;
    border: 1px solid #494949;
    border-radius: 13px;
    padding: 36px;
    font-weight: 600;
    background-color: transparent;
    width: 600px;
    margin: 0 auto;
}

.strategies_form form {
    width: 100%;
    margin-top: 12px;
}

.strategies_form h4 {
    display: flex;
    gap: 12px;
    align-items: center;
    font-size: 18px;
}

.strategies_form form .op_traders_step {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.search_currency .modal-content {
    background-color: #222222;
}

.search_currency .modal-header {
    border-bottom: none;
}

.search_currency .search_form {
    border: 1px solid #474747;
}

.search_currency .search_form input {
    background-color: transparent;
    border: none;
}

.Currency_list_select {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
    max-height: 260px;
    overflow: auto;
}

.currency_item {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 15px;
}

.text-succes {
    color: #01BC8D;
}

.currency_item h5 {
    font-size: 15px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin: 0px;
}

.search_currency button.btn-close {
    background-color: #fff;
    opacity: 1;
    border-radius: 50px;
    font-size: 12px;
    top: -13px;
    position: relative;
    right: -4px;
}

.currency_item h5 span {
    font-size: 13px;
}

.currency_item img.token-icon {
    width: 30px;
    border-radius: 50px;
}

.op_traders_step .input_block {
    display: flex;
    gap: 10px;
    align-items: center;
}

.op_traders_step .input_block label {
    font-size: 14px;
    color: #fff;
    min-width: 100px;
    color: #c4c4c4;
}

.op_traders_step .input_block .select_option {
    width: 100%;
    background-color: transparent;
    border: 1px solid #494949;
    border-radius: 6px;
    padding: 8px;
    font-size: 14px;
}

.mobile_view {
    display: none;
}

.input_inserst {
    width: 100%;
    background-color: transparent;
    border: 1px solid #494949;
    border-radius: 6px;
    padding: 8px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.input_inserst input {
    background-color: transparent;
    border: none;
    width: 80%;
    color: #999;
}

input:focus-visible {
    outline: none;
}

.submitbtn {
    background-color: #fcd535;
    border: none;
    font-weight: 600;
    font-size: 18px;
    padding: 10px 15px;
    border-radius: 8px;
}


.toggle_righsidebar {
    width: 300px;
    color: #c9c9c9;
    position: absolute;
    right: 0px;
    background-color: #1e2329;
    border: 1px solid #2b3139;
    top: 0px;
    padding: 16px;
    display: none;
}

.toggle_righsidebar::before {
    width: 299px;
    background-color: #1e2329;
    position: fixed;
    content: "";
    height: 100%;
    bottom: 0px;
    right: 0;
}

.toggle_righsidebar.active {
    display: block;
}

.top_hd svg {
    width: 18px;
}

.closebtn {
    cursor: pointer;
}

.top_sidebar_main {
    position: relative;
}

.top_hd {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    justify-content: space-between;
}

.top_hd .leftcnt {
    display: flex;
    align-items: center;
    gap: 10px;
}

.top_hd h4 {
    font-size: 16px;
    margin: 0px;
    display: flex;
    gap: 5px;
}

.sidebartabs .nav-tabs-check {
    flex-wrap: nowrap;
    border: none;
}

.sidebartabs .nav-tabs-check li {
    width: 100%;
}

.sidebartabs .nav-tabs-check .nav-link-check {
    color: #848e9c;
    border: none;
    font-size: 15px;
    width: 100%;
    border-radius: 50px;
    padding: 4px 15px;
}

.sidebartabs .nav-tabs-check .nav-link-check.active {
    background-color: #feba00;
    color: #000;
    font-weight: 500;
}

.bn_bubble_content {
    font-size: 13px;
    background-color: #feba001a;
    display: inline-block;
    padding: 2px 5px;
    border-radius: 4px;
    color: #feba00;
    margin: 5px 0px;
}

.sidebartabs {
    margin-top: 12px;
    font-size: 14px;
}

.avbl_usdt .d-flex {
    gap: 5px;
}

.evenodd_icon svg {
    width: 20px;
}

.evenodd_icon svg path {
    color: #feba00;
}

.price_stbs .price {
    display: flex;
    gap: 5px;
}

.price_stbs .price svg {
    width: 18px;
}

.bn_textField_inp {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    background-color: #2b3139;
    border-radius: 7px;
    margin-top: 10px;
}

.bn_textField_inp input {
    width: 90%;
    background-color: transparent;
    border: none;
    padding: 10px;
    color: #999;
}

.bn_textField_inp .text_primarytext {
    padding: 10px;
}

.tif_ios_cnt {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-top: 1px solid #2b3139;
    padding: 20px 0px;
    border-bottom: 1px solid #2b3139;
    margin-top: 20px;
}

.tif_ios_cnt ul {
    display: flex;
    gap: 10px;
    align-items: center;
}

.tif_ios_cnt ul li a {
    gap: 0px;
    display: flex;
    color: #c9c9c9;
}

.tif_ios_cnt ul li select {
    background-color: transparent;
    border: none;
    color: #fff;
}

.tif_ios_cnt ul li select option {
    color: #000;
}

button.bn-button.button__buy {
    background-color: #feba00;
    border: none;
    font-size: 16px;
    font-weight: 500;
    padding: 10px;
    border-radius: 10px;
}

.toggle_righsidebar .account_block_s {
    padding: 0px;
}

.toggle_righsidebar .account_tabs_info h5 {
    font-size: 16px;
}

.toggle_righsidebar .account_tabs_info ul {
    font-size: 13px;
}

.account_tabs_info ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    color: #c9c9c9;
}

.account_hd_div {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
}

.account_currency_cate {
    margin: 10px 0px;
    overflow: auto;
}

.account_currency_cate ul {
    display: flex;
    gap: 15px;
    flex-direction: row;
    flex-wrap: nowrap;
}

.account_currency_cate ul li a {
    font-size: 14px;
    font-weight: 400;
}

.account_hd_div svg {
    width: 20px;
}

.account_hd_div svg path {
    fill: #feba00;
}

.account_hd_div h2 {
    font-size: 18px;
}

.dotted_toggle {
    width: 18px;
    cursor: pointer;
}

.togglehide_cnt {
    position: absolute;
    width: 200px;
    padding: 15px;
    background-color: #1e2329;
    right: 0px;
    top: 24px;
    border: 1px solid #9999993d;
    border-radius: 10px;
    display: none;
}

.togglehide_cnt.active {
    display: flex;
}

.togglehide_cnt ul {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.togglehide_cnt ul li {
    align-items: center;
    gap: 7px;
    display: flex;
    font-size: 14px;
}

.modal.currency_popup_s.crosstabs .modal-dialog {
    max-width: 450px;
    min-width: 450px;
    width: 100%;
}

.modal.currency_popup_s.crosstabs .modal-content {
    background: #2a2a2a;
    border-radius: 20px;
}

.modal.currency_popup_s.crosstabs .modal-header {
    border: none;
    padding-bottom: 0px;
}

.modal.currency_popup_s .btn-close {
    background-color: #f3bb2b;
    font-size: 11px;
    opacity: 1;
    border-radius: 50px;
}

.modal.currency_popup_s.crosstabs .modal-body {
    display: flex;
    justify-content: center;
    gap: 5px;
    color: #ffffffe6;
    flex-direction: column;
    align-items: start;
    text-align: left;
    padding: 0px 32px 32px;
}

.modal.currency_popup_s.crosstabs .modal-body h4 {
    font-size: 17px;
    margin-top: 18px;
}

.modal.currency_popup_s.crosstabs .modal-body h4 sup {
    font-size: 13px;
    font-weight: 300;
    background-color: #0000003b;
    padding: 4px 8px;
    border-radius: 5px;
}

.isolated_checked {
    border-bottom: 1px solid #9999992e;
    width: 100%;
    padding-bottom: 7px;
    margin: 13px 0px;
}

.user_identyid {
    max-width: 120px;
    margin: 0;
    margin-bottom: 20px;
    opacity: 0.7;
}

.modal.currency_popup_s.crosstabs p {
    font-size: 14px;
    line-height: 24px;
}

.modal.currency_popup_s.crosstabs p.redcolor {
    color: rgb(209, 55, 55);
}

.range_value {
    width: 100%;
}

.range_valuebox {
    width: 100%;
    border: 1px solid #9999993b;
    display: flex;
    padding: 10px;
    border-radius: 8px;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
}

.range_valuebox input {
    background-color: transparent;
    border: none;
    color: #ffffffcc;
    font-size: 14px;
    text-align: center;
}

.value_selected {
    position: relative;
    margin-top: 8px;
}

/* .value_selected::before {
    width: 100%;
    height: 1px;
    background-color: #ffffff40;
    content: "";
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -20%);
} */

.value_selected ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    text-align: center;
}

.value_selected ul li {
    font-size: 13px;
    position: relative;
    color: #ffffff75;
    margin: -6px 0px 10px;
}

.value_selected ul li:first-child {
    text-align: left;
}

.value_selected ul li:last-child {
    text-align: right;
}

.value_selected ul li:last-child::before {
    margin-right: 0px;
}

.value_selected ul li:first-child::before {
    margin-left: 0px;
}

.value_selected ul li::before {
    width: 7px;
    height: 7px;
    background-color: #adadad;
    border-radius: 100%;
    content: "";
    position: absolute;
    top: -16px;
    margin: 0 auto;
    left: 0px;
    right: 0px;
}

.btnsupport {
    flex-direction: column;
    width: 100%;
    gap: 5px;
}

.btnsupport button {
    font-size: 16px;
    padding: 10px 24px;
    border-radius: 50px;
    border: none;
    font-weight: 500;
    background-color: #f3bb2b;
}

.btnsupport button.customerbtn {
    background-color: transparent;
    border-radius: 0px;
    color: #f3bb2b;
}

.modal.currency_popup_s.crosstabs .modal-body.free_rate {
    align-items: start;
    text-align: left;
    padding: 15px 32px 32px;
}

.modal.currency_popup_s.crosstabs .modal-body.free_rate ul {
    align-items: start;
    width: 100%;
    margin: 10px 0px 24px;
    flex-direction: column;
}

.modal.currency_popup_s.crosstabs .modal-body.free_rate ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    width: 100%;
}

.price_stbs .price a {
    color: #fff;
}

button.bn-button.button__buy.sellbtn {
    background-color: #f65454;
    color: #fff;
}

.top_table_data {
    display: flex;
    justify-content: space-between;
    align-items: start;
    border-bottom: 1px solid #f3f3f329;
    min-height: 200px;
    max-height: 500px;
    overflow: auto;
}

.recent_tables_outer .tables_calls .table-responsive,
.recent_tables_outer .tables_puts .table-responsive {
    min-height: 150px;
    max-height: 150px;
    overflow: auto;
}

::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
    background: #1e1e1e;
}

::-webkit-scrollbar-thumb {
    background-color: #444;
    border-radius: 10px;
    border: 2px solid #1e1e1e;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #666;
}

/* * {
    scrollbar-width: thin;
    scrollbar-color: #444 #1e1e1e;
} */

.top_table_data .lefside_data {
    width: 100%;
}

.top_table_data .table-responsive {
    min-height: 100%;
    max-height: 100%;
}

.top_table_data .right_data {
    width: 100%;
}

.top_table_data .mid_data {
    min-width: 140px;
    text-align: center;
}

.topnav_selected .form-check-label:before {
    display: none;
}

.data_option_calls table tr td span {
    display: block;
    color: #999;
}

.option_block_outer .esay_option_table {
    padding: 0px;
}

@media screen and (max-width:1550px) {

    .top_future_left_s ul {
        gap: 15px;
    }

    .top_bar_usd_future {
        /* overflow: auto; */
    }

}


@media screen and (max-width:1440px) {
    .data_option_calls table tr th {
        white-space: nowrap;
    }

    .recent_trades_options table tr th {
        white-space: nowrap;
    }


    .algo_orders_outers .nav-tabs-check {
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: auto;
    }

    .placebtn button {
        padding: 16px 20px;
        font-size: 20px;
    }

    .algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check {
        padding: 18px 15px;
    }

    .request_quote_btn button {
        font-size: 18px;
        padding: 16px 0px 20px;
    }

    .crypto_section .hot_trading_s.top_gainers th,
    td {
        font-size: 12px;
    }

}

@media screen and (max-width:1200px) {

    .usd_left_pr {
        width: 100%;
    }


    .futuresflex .assets_right {
        width: 100%;
    }

    .trade_option_bl {
        padding: 20px;
    }

    .top_barcalls_put_cnt ul li {
        font-size: 12px;
    }

    .top_future_left_s {
        width: 70%;
        overflow: auto;
        white-space: nowrap;
    }

    .price_info .buysell_btn {
        flex-direction: column;
    }

    .price_info .buysell_btn button {
        width: 100%;
    }

    .trade_movers_tb ul.nav-tabs-check {
        gap: 10px;
    }

    .trade_movers_tb button.nav-link-check {
        font-size: 12px;
    }

    .submitbtn button {
        font-size: 18px;
        padding: 15px 10px;
    }

    .createblock_form .creatblock_left_inquery .nav-tabs-check li .nav-link-check {
        font-size: 18px;
        padding: 15px 15px;
    }

    .markert_overview_right h3 {
        font-size: 20px;
    }

    .markert_overview_right {
        padding: 24px;
    }

    .creatblock_left_inquery .form_input select {
        font-size: 15px;
    }

    .creatblock_left_inquery .form_input input {
        font-size: 15px;
    }

    .createblock_form {
        padding: 70px 0px 40px;
    }

    .trade_summary_table_lft .nav-tabs-check {
        gap: 5px;
        overflow: scroll;
        white-space: nowrap;
        flex-wrap: nowrap;
    }

    .algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check {
        padding: 16px 15px;
    }

    .h1,
    h1 {
        font-size: 30px;
    }

    .orders_leftside h2 {
        font-size: 24px;
    }

    .options_section ul li button {
        font-size: 15px;
        border-radius: 10px;
    }

    .strategies_cate ul {
        white-space: nowrap;
        overflow: auto;
    }

    .request_quote_btn button {
        font-size: 18px;
        padding: 15px 0px 20px;
    }

    .placebtn button {
        padding: 18px 20px;
        font-size: 18px;
    }

    .algo_detail_summary_left h5 {
        font-size: 16px;
    }

    .portal_chat_top ul {
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: scroll;
    }


    .top_future_right_s {
        overflow: auto;
        width: 35%;
        white-space: nowrap;
    }

    .top_bar_usd_future {
        align-items: end;
    }

    .trade_summary_table_lft.esay_option_table .nav-tabs-check {
        flex-wrap: nowrap;
        overflow: auto;
        white-space: nowrap;
    }

    .classic_usd_right ul {
        overflow: scroll;
        gap: 20px;
    }

    .classic_option_top {
        overflow: hidden;
    }


    .trade_account_summary_assets {
        flex-direction: column;
    }

    .trade_summary_table_lft {
        width: 100%;
    }

    .assets_right {
        width: 100%;
    }

    body .crypto_section .hot_trading_s.top_gainers th,
    td {
        font-size: 12px;
    }

}


@media screen and (max-width:991px) {

    .dashboard_mid_s .dashboard_summary_lft {
        width: 100%;
    }

    .price_info .buysell_btn {
        flex-direction: row;
    }


    .trade_summary_table_lft p.text-center.no-data.h-100.mb-0.center_b {
        padding: 10px 0px 0px;
    }

    .option_block_process {
        border-radius: 24px;
        padding: 24px;
        margin-top: 24px;
    }

    .markert_overview_right ul li {
        font-size: 15px;
    }

    .row.classic_favorites_bl {
        flex-direction: column;
    }

    .row.classic_favorites_bl .col-sm-9 {
        width: 100%;
    }

    .row.classic_favorites_bl .col-sm-3 {
        width: 100%;
    }

    .recent_tables_outer {
        flex-direction: column;
    }

    .dashboard_mid_s {
        flex-direction: column;
    }

    .algo_detail_summary .row {
        flex-direction: column;
    }

    .algo_detail_summary .row .col-sm-4 {
        width: 100%;
    }

    .algo_detail_summary .row .col-sm-8 {
        width: 100%;
    }

    .topbar_order {
        align-items: start;
        flex-direction: column;
        gap: 15px;
    }

    .portal_chat_top ul {
        justify-content: center;
    }

    .algo_order_right {
        margin-top: 30px;
    }

    .algo_orders_outers .nav-tabs-check {
        width: 100%;
    }

    .portal_chat_top {
        width: 100%;
    }

    .dashboard_mid_s.space_gap_0 .order_trade_s {
        width: 100%;
    }

    .relative_select_right {
        width: 100%;
        padding-top: 15px;
    }

    .table_info_data table tr .subtotal {
        text-align: left;
    }


    .relative_select_right_mobile_tabs.d-lg-none {
        display: none;
    }




    .market_spot_form {
        padding-bottom: 24px;
    }

    .trade_summary_table_lft .tab-content {
        min-height: 100px;
    }

    .prediction_detail ul.nav-tabs-check {
        margin-top: 18px;
        gap: 12px;
    }

    .trade_summary_table_lft tr td button {
        white-space: nowrap;
    }

    .top_future_right_s {
        padding-bottom: 8px;
    }

    .top_future_left_s {
        padding-bottom: 8px;
    }

}


/* 991px tak: relative_select_right sirf Buy/Sell click par show (mobile jaisa) */
@media screen and (max-width: 991px) {

    .relative_select_right {
        display: none !important;
    }

    .relative_select_right.mobile_order_panel_open,
    .dashboard_mid_s .relative_select_right.mobile_order_panel_open,
    .space_gap_0 .relative_select_right.mobile_order_panel_open {
        display: block !important;
        position: fixed !important;
        bottom: 0;
        left: 0;
        right: 0;
        height: 80vh !important;
        max-height: 80vh !important;
        min-height: 0 !important;
        z-index: 1055;
        overflow-y: auto !important;
        overflow-x: hidden;
        background: var(--body-bg, #0d0d14);
        padding: 56px 15px 20px;
        width: 100%;
        box-sizing: border-box;
        -webkit-overflow-scrolling: touch;
    }

    .relative_select_right_mobile_close {
        display: flex !important;
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 1060;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #f3bb2b;
        border: none;
        /* background: none; */
        color: #181a20;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 200;
        cursor: pointer;
        padding: 0;
    }

    .relative_select_right_mobile_tabs {
        display: flex;
        gap: 0;
        margin-bottom: 16px;
        border-bottom: 1px solid #2a2a3a;
    }

    .relative_select_right_mobile_tabs button {
        flex: 1 1;
        padding: 12px 16px;
        border: none;
        background: transparent;
        color: #888;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        margin-bottom: -1px;
    }

    .relative_select_right_mobile_tabs button.active {
        color: #fff;
    }

    .relative_select_right_mobile_tabs button:first-child.active {
        border-bottom-color: #22c55e;
    }

    .relative_select_right_mobile_tabs button:last-child.active {
        border-bottom-color: #ef4444;
    }

    .relative_select_right_mobile_backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1050;
    }
}


@media screen and (max-width:767px) {

    .dashboard_mid_s .order_trade_s {
        display: none !important;
    }

    .modal.currency_popup_s.futures_usd_modal .modal-header {
        padding: 14px 15px;
    }

    .modal.currency_popup_s.futures_usd_modal .modal-body {
        padding: 0px;
    }

    .modal.currency_popup_s.futures_usd_modal .currency_data_list table tr td {
        padding: 5px 7px;
    }

    .modal.currency_popup_s.futures_usd_modal .currency_data_list table tr th {
        padding: 5px 7px !important;
    }

    .modal.currency_popup_s.futures_usd_modal .currency_data_list {
        margin-top: 12px;
    }

    table tr .lastchild {
        text-align: right;
    }

    .search_form_container {
        padding: 0px 10px;
    }

    .modal.currency_popup_s.futures_usd_modal .modal-dialog .modal-content {
        border-radius: 10px 10px 0px 0px;
    }

    .modal.currency_popup_s.futures_usd_modal .tab-content>.tab-pane {
        padding-right: 0px;
    }

    .modal.currency_popup_s.futures_usd_modal h4 {
        font-size: 15px;
        margin: 0px;
    }

    .future_data_mobile>div {
        min-height: auto !important;
        /* height: auto !important; */
    }

    .assets_right {
        display: none !important;
    }

    .relative_select_right {
        display: none !important;
    }

    .relative_select_right.mobile_order_panel_open,
    .dashboard_mid_s .relative_select_right.mobile_order_panel_open,
    .space_gap_0 .relative_select_right.mobile_order_panel_open {
        display: block !important;
        position: fixed !important;
        bottom: 0;
        left: 0;
        right: 0;
        height: 70vh !important;
        max-height: 70vh !important;
        min-height: 0 !important;
        z-index: 999999;
        overflow-y: auto !important;
        overflow-x: hidden;
        background: var(--body-bg, #0d0d14);
        padding: 20px 15px 20px;
        width: 100%;
        box-sizing: border-box;
        -webkit-overflow-scrolling: touch;
    }

    .relative_select_right_mobile_close {
        top: 5px;
        right: 10px;
    }

    .price_inputbl.value_choose {
        padding-top: 10px;
    }

    .price_inputbl ul li button {
        font-size: 11px;
    }

    .relative_select_right_mobile_tabs {
        display: none;
        gap: 0;
        margin-bottom: 16px;
        border-bottom: 1px solid #2a2a3a;
    }

    .relative_select_right_mobile_tabs button {
        flex: 1 1;
        padding: 12px 16px;
        border: none;
        background: transparent;
        color: #888;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        margin-bottom: -1px;
    }

    .relative_select_right_mobile_tabs button.active {
        color: #fff;
    }

    .relative_select_right_mobile_tabs button:first-child.active {
        border-bottom-color: #22c55e;
    }

    .relative_select_right_mobile_tabs button:last-child.active {
        border-bottom-color: #ef4444;
    }

    .relative_select_right_mobile_backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1050;
    }

    #TVFuturesChartContainer iframe {
        /* height: 600px !important; */
    }

    .modal.currency_popup_s .modal-dialog .modal-content {
        border-radius: 0px;
    }

    body .modal.currency_popup_s .modal-dialog {
        min-width: 100%;
    }

    .buysell_btn button {
        padding: 5px 24px;
        font-size: 12px;
    }

    .trade_account_summary_assets {
        flex-direction: column-reverse;
    }

    .price_info .buysell_btn {
        flex-direction: row;
    }

    .trade_summary_table_lft .table-responsive {
        align-items: start;
        min-height: 260px;
        max-height: 270px;
        display: block;
    }

    .price_select_option {
        font-size: 12px;
    }

    .price_inputbl select {
        font-size: 12px;
    }

    .trade_summary_table_lft tr td {
        padding: 7px;
    }

    .trade_summary_table_lft .nav-tabs-check li button {
        font-size: 12px;
    }

    .currency_data_list table h6 {
        font-size: 12px;
    }

    .currency_data_list table tr td p {
        font-size: 12px;
    }

    .range_valuebox input {
        width: 100px;
        font-size: 12px;
    }

    .buy_transferbtn button {
        font-size: 12px;
        padding: 5px 22px;
    }

    .modal.currency_popup_s.crosstabs .modal-body {
        padding: 0px 20px 20px;
    }

    .modal.currency_popup_s.crosstabs .modal-body h4 {
        font-size: 13px;
        margin-top: 14px;
    }

    .modal.currency_popup_s.crosstabs .modal-body h4 sup {
        font-size: 10px;
    }

    .modal.currency_popup_s.crosstabs .modal-body h3 {
        font-size: 18px;
    }

    .modal.currency_popup_s.crosstabs p {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .btnsupport button {
        font-size: 12px;
        padding: 6px 24px;
    }

    .option_block_process ul {
        gap: 24px;
        flex-direction: column;
    }

    .createblock_form {
        padding: 40px 0px 20px;
    }

    .createblock_form .nav-tabs-check li .nav-link-check {
        font-size: 14px;
    }

    .option_block_process ul li h2 {
        font-size: 18px;
    }

    .algo_detail_summary p {
        margin-bottom: 0px;
    }

    .option_block_outer h1 {
        font-size: 24px;
    }

    .top_table_data .mid_data.mobile_view {
        display: flex;
        min-width: auto;
    }

    .top_table_data .right_data {
        display: flex;
    }

    h5.mobile {
        display: block;
    }

    .top_table_data {
        max-height: 100%;
    }

    .top_table_data .mid_data {
        min-width: 100%;
        padding: 0px 0px;
    }

    .top_table_data .mid_data tr td {
        height: 47px;
    }

    .top_table_data .lefside_data {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
    }

    .recent_trades_options h6 {
        padding: 0px 0px;
    }

    h5.mobile {
        padding: 10px 0px 0px;
        font-size: 16px;
    }

    .recent_tables_outer {
        flex-direction: column;
        gap: 24px;
    }

    .recent_tables_outer .tables_calls .table-responsive,
    .recent_tables_outer .tables_puts .table-responsive {
        min-height: 250px;
        max-height: 250px;
    }

    .data_option_calls table tr td {
        font-size: 12px;
        padding: 8px;
    }

    .recent_trades_options table tr th {
        white-space: nowrap;
    }

    .top_table_data {
        flex-direction: column;
    }

    .top_barcalls_put_cnt ul {
        gap: 20px;
        padding: 10px 20px;
    }

    .container,
    .container-sm {
        max-width: 90%;
    }

    .d-flex.topnav_selected {
        flex-direction: column;
    }

    .topnav_selected .nav-tabs-check {
        width: 100%;
    }

    .right_top_r {
        padding: 0px 13px;
        width: 100%;
    }

    .orderbook_lightbox {
        right: inherit;
        padding: 18px;
    }

    .data_option_calls table tr th {
        white-space: nowrap;
        padding: 10px 15px;
        font-size: 12px;
    }

    .classic_usd_right ul li .cnt_top_cl h6 {
        font-size: 12px;
    }

    .classic_usd_right ul li .cnt_top_cl p {
        font-size: 12px;
    }

    .trade_option_bl {
        padding: 18px;
    }

    .account_block_s {
        padding: 18px;
    }

    .account_currency_cate ul li a {
        font-size: 12px;
    }

    .recent_trades_options table tr td {
        padding: 10px 15px;
        font-size: 12px;
    }

    .portal_chat_top {
        padding: 0px 20px;
    }

    .top_barcalls_put_cnt ul {
        white-space: nowrap;
        overflow: scroll;
        justify-content: space-around;
    }

    .h1,
    h1 {
        font-size: 24px;
    }

    h2 {
        font-size: 20px;
    }

    .orders_leftside h2 {
        font-size: 20px;
    }

    .algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check {
        padding: 11px 12px;
        font-size: 14px;
    }

    .morebtn_right button {
        padding: 6px 16px;
    }

    .algo_detail_summary_left h5 {
        font-size: 14px;
    }

    .options_section ul {
        gap: 15px;
        margin-top: 15px;
        overflow: scroll;
    }

    .strategies_form {
        font-size: 18px;
        padding: 24px;
        width: 100%;
    }

    .placebtn button {
        padding: 12px 20px;
        font-size: 16px;
    }

    .algo_orders_outers .nav-tabs-check li .nav-link-check {
        font-size: 14px;
    }

    .portal_chat_top ul li a {
        font-size: 14px;
    }

    .section_trading .dropdown-toggle {
        padding: 7px 14px;
        font-size: 15px;
    }

    .section_trading .price {
        font-size: 18px;
    }

    .options_section ul li button {
        font-size: 14px;
    }

    .d-flex.justify_currency {
        font-size: 15px;
    }

    .request_quote_btn button {
        font-size: 15px;
        padding: 13px 0px 13px;
    }

    .refresh_cntr {
        width: 42px;
    }

    .total_balance {
        font-size: 14px;
    }

    span.green {
        font-size: 15px;
    }

    .d-flex.top_bar_hd h4 {
        font-size: 20px;
    }

    .submitbtn {
        font-size: 15px;
        padding: 8px 15px;
    }

    .trade_summary_table_lft.esay_option_table h2 {
        margin: 15px 0px;
    }

    .portal_chat_top ul {
        justify-content: start;
    }

    .portal_chat_top ul li {
        font-size: 13px;
    }

    .row.prediction_row {
        flex-direction: column;
        gap: 24px;
    }

    .prediction_detail {
        min-height: 100%;
    }

    .prediction_detail ul {
        gap: 32px;
        margin-top: 30px;
    }

    .fill_cnt {
        padding: 20px 0px 0px;
    }

    .row.prediction_row .col-sm-4 {
        width: 100%;
    }

    .prediction_top_s {
        padding: 20px 0px;
    }

    .buy_sell_option {
        padding: 30px 0px 40px;
    }

    .buy_sell_option .row {
        flex-direction: column;
        gap: 24px;
    }

    .buy_sell_option .row .col-sm-4 {
        width: 100%;
    }

    button.bn-button.button__buy {
        font-size: 14px;
        padding: 7px 10px;
        border-radius: 6px;
    }

    .search_form .modal-body {
        padding: 24px !important;
    }

    .trade_summary_table_lft .tab-content {
        min-height: 60px;
    }

    .trade_summary_table_lft .nav-tabs-check {
        gap: 5px;
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: auto;
    }

    .price_top_right {
        font-size: 14px;
    }

    .price_top_right span {
        font-size: 12px;
    }

    .prediction_detail ul li img {
        width: 42px;
    }

    body {
        font-size: 14px;
    }

    .prediction_detail ul.nav-tabs-check {
        flex-wrap: nowrap;
        white-space: nowrap;
        overflow: scroll;
    }

    .buy_sell_option .nav-tabs-check li button.nav-link-check {
        font-size: 14px;
        padding: 5px 10px;
    }

    .buy_sell_option .nav-tabs-check {
        margin-top: 18px;
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow: scroll;
    }

    .trade_summary_table_lft tr th {
        padding: 6px 15px;
        white-space: nowrap;
    }

    .account_hd_div {
        margin-top: 0px;
    }

    .createblock_form>.tab-content {
        margin-top: 20px;
    }

    .createblock_form .creatblock_left_inquery .nav-tabs-check li .nav-link-check {
        font-size: 15px;
        padding: 12px;
    }

    .creatblock_left_inquery .tab-content {
        padding: 24px;
    }

    .buyform form .row {
        row-gap: 20px;
    }

    .creatblock_left_inquery .form_input input {
        font-size: 14px;
        padding: 10px 15px;
    }

    .creatblock_left_inquery .form_input.fullsize select {
        padding: 10px 15px;
    }

    .submitbtn button {
        font-size: 15px;
        padding: 12px 10px;
    }

    .createblock_form .row {
        gap: 24px;
    }

    .markert_overview_right ul {
        padding-top: 15px;
        gap: 15px;
    }

    .notfound_vector {
        max-width: 120px;
        margin: 30px auto;
    }

    .table_info_data table tr th {
        font-size: 12px;
    }

    .table_info_data table tr.totaltb td.danger {
        font-size: 15px;
    }

    .trade_movers_tb button.nav-link-check {
        font-size: 13.5px;
    }

    .top_cross_dashboard ul li a {
        padding: 4px 12px 4px;
        font-size: 12px;
    }

    .usd_future_dashboard .dashboard_mid_s {
        gap: 20px;
    }

    .top_cross_dashboard ul {
        gap: 10px;
    }

    .trade_summary_table_lft p.text-center.no-data.h-100.mb-0.center_b {
        padding: 40px 0px 0px;
    }

}

@media screen and (max-width:660px) {

    .top_bar_usd_future {
        align-items: normal;
        flex-direction: column;
        gap: 15px;
    }



    .modal.currency_popup_s .modal-dialog {
        max-width: 70%;
        margin: 20px auto;
    }

    .topnav_selected .nav-tabs-check .nav-link-check {
        padding: 4px 7px;
        font-size: 12px;
    }

    .top_barcalls_put_cnt ul li {
        font-size: 12px;
    }

    .range_valuebox {
        padding: 5px 10px;
    }

    .value_selected ul li {
        font-size: 11px;
    }

    .price_top_right {
        font-size: 12px;
    }

    .top_future_left_s ul li {
        font-size: 12px;
    }

    .trade_option_bl .row {
        gap: 24px;
    }

    .createblock_form .nav-tabs-check li .nav-link-check {
        font-size: 13px;
    }


    .currency_popup_s h4 {
        font-size: 18px;
    }

    .trade_option_bl .row .col-sm-6 {
        width: 100%;
    }

    .modal.currency_popup_s.crosstabs .modal-dialog {
        max-width: 90%;
        min-width: 90%;
        margin: 0 auto;
    }

    .buy_sell_option h5 {
        font-size: 18px;
    }

    .hide_underlying_s {
        justify-content: start;
        padding: 10px 10px 0px;
        margin-bottom: 15px;
    }

    .top_future_left_s {
        width: 100%;
    }

    .top_future_right_s {
        width: 100%;
    }

    .trade_summary_table_lft .nav-tabs-check {
        gap: 5px;
    }

    .prediction_up img.prediction_vector {
        min-height: 120px;
        width: 150px;
    }

    .prediction_up {
        gap: 15px;
    }

    .space_gap_0.dashboard_mid_s .relative_select_right {
        padding: 28px 15px 15px !important;
    }


}

.text-green {
    color: #2BC287 !important;
}

.text-red {
    color: #E45561 !important;
}

.table-trade {
    overflow: clip;
    height: 210px;
}

.desktop_view .topnav_selected ul li.active button {
    border: 1px solid #f3bb2b;
}


.nav-check {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    padding: 0px 10px;

}

.market-close {
    background-color: #2c2c2c !important;
    border-color: #2c2c2c !important;
    padding: 4px 8px !important;
    border-radius: 4px !important;
    text-align: center !important;
    border: none !important;
    font-size: 12px !important;
    color: #dfdfdf !important;
    font-weight: 300 !important;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/FuturesAndOptions/CoinFutures.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,QAAQ;IACR,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;IAClC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;IAClC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,kEAAkE;AAClE;IACI,cAAc;IACd,YAAY;IACZ,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;;;AAIA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,gCAAgC;IAChC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kCAAkC;IAClC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,WAAW;IAEX,8BAA8B;IAE9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IAEb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iCAAiC;IACjC,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;;;;;AAMA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,OAAO;IACP,UAAU;IACV,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,QAAQ;IACR,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B;IAC7B,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;;;;;;GASG;;AAEH;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,SAAS;IACT,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;GAGG;;AAEH;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI;QACI,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;;AAEJ;;;AAGA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;;IAGA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,WAAW;IACf;;;IAGA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,QAAQ;QACR,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;IACpB;;;IAGA;QACI,cAAc;QACd,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,eAAe;IACnB;;AAEJ;;;AAGA;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;;IAGA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,aAAa;IACjB;;;;;IAKA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;;;AAGA,iFAAiF;AACjF;;IAEI;QACI,wBAAwB;IAC5B;;IAEA;;;QAGI,yBAAyB;QACzB,0BAA0B;QAC1B,SAAS;QACT,OAAO;QACP,QAAQ;QACR,uBAAuB;QACvB,2BAA2B;QAC3B,wBAAwB;QACxB,aAAa;QACb,2BAA2B;QAC3B,kBAAkB;QAClB,mCAAmC;QACnC,uBAAuB;QACvB,WAAW;QACX,sBAAsB;QACtB,iCAAiC;IACrC;;IAEA;QACI,wBAAwB;QACxB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,aAAa;QACb,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,sBAAsB;QACtB,cAAc;QACd,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,UAAU;IACd;;IAEA;QACI,aAAa;QACb,MAAM;QACN,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;QACI,SAAO;QACP,kBAAkB;QAClB,YAAY;QACZ,uBAAuB;QACvB,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,oCAAoC;QACpC,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,8BAA8B;QAC9B,aAAa;IACjB;AACJ;;;AAGA;;IAEI;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;;QAGI,yBAAyB;QACzB,0BAA0B;QAC1B,SAAS;QACT,OAAO;QACP,QAAQ;QACR,uBAAuB;QACvB,2BAA2B;QAC3B,wBAAwB;QACxB,eAAe;QACf,2BAA2B;QAC3B,kBAAkB;QAClB,mCAAmC;QACnC,uBAAuB;QACvB,WAAW;QACX,sBAAsB;QACtB,iCAAiC;IACrC;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,MAAM;QACN,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;QACI,SAAO;QACP,kBAAkB;QAClB,YAAY;QACZ,uBAAuB;QACvB,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,oCAAoC;QACpC,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,8BAA8B;QAC9B,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,QAAQ;QACR,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,qBAAqB;IACzB;;AAEJ;;AAEA;;IAEI;QACI,mBAAmB;QACnB,sBAAsB;QACtB,SAAS;IACb;;;;IAIA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kCAAkC;IACtC;;;AAGJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,2BAA2B;IAC3B,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;AAC/B","sourcesContent":["img {\n    max-width: 100%;\n}\n\nul {\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n}\n\na {\n    text-decoration: none;\n}\n\nbody {\n    background-color: #121212;\n}\n\n.usd_future_dashboard {\n    width: 100%;\n    display: block;\n    background-color: #121212;\n    height: 100%;\n    color: #fff;\n    padding: 0px 10px;\n}\n\n.top_bar_usd_future {\n    width: 100%;\n    gap: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n\n.dashboard_mid_s .order_trade_s .futurestbllft .table_info_data table tr td {\n    min-width: 100px;\n}\n\n.usd_left_pr {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    width: 290px;\n}\n\n.top_future_left_s ul li:nth-child(5) {\n    min-width: 150px;\n}\n\n.top_future_left_s ul li:nth-child(4) {\n    min-width: 130px;\n}\n\n.top_future_left_s ul li:nth-child(3) {\n    min-width: 110px;\n}\n\n.market_price_list_top {\n    width: 73%;\n}\n\n.price_top_right {\n    min-width: 130px;\n    font-size: 16px;\n    color: #01BC8D;\n    font-weight: 500;\n    line-height: 19px;\n    display: flex;\n    flex-direction: column;\n    white-space: nowrap;\n}\n\n.currency_popup_s .search_form input {\n    padding: 5px 15px;\n    color: #fff;\n}\n\n.no-data {\n    margin: 0 auto;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    /* width: 100%; */\n}\n\n.price_top_right span {\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.btcusd__currency span {\n    width: 18px;\n    height: 18px;\n    border: 1px solid #434343;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50px;\n}\n\n.btcusd__currency {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 500;\n}\n\n.top_future_left_s {\n    display: flex;\n    align-items: center;\n    gap: 18px;\n    width: 75%;\n    justify-content: start;\n}\n\n.top_future_left_s ul {\n    display: flex;\n    align-items: center;\n    gap: 22px;\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n}\n\n.top_future_left_s ul li span {\n    color: #6C6C6C;\n}\n\n.top_future_left_s ul li {\n    font-size: 12px;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.top_future_left_s ul li span.yellow {\n    color: hsl(33, 97%, 58%);\n}\n\n.top_future_right_s {\n    text-align: right;\n    width: 25%;\n}\n\n.top_future_right_s ul {\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.top_future_right_s ul li {\n    color: #c3c3c3;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 12px;\n    padding-right: 12px;\n    border-right: 1px solid #222222;\n    line-height: 10px;\n    cursor: pointer;\n}\n\n.success-color {\n    color: #01bc8d;\n}\n\n.danger-color {\n    color: #f75455;\n}\n\n\n.top_future_right_s ul li:last-child {\n    border: none;\n}\n\n.dashboard_mid_s {\n    width: 100%;\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n    margin-top: 8px;\n}\n\n.dashboard_mid_s .dashboard_summary_lft {\n    width: 60%;\n    padding: 5px 10px;\n    background: #181A20;\n    overflow: hidden;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    position: relative;\n    color: #fffffff2;\n}\n\n.dashboard_mid_s .dashboard_summary_lft img {\n    width: 100%;\n}\n\n.order_trade_s {\n    width: 16%;\n    padding: 0px;\n    background: #181A20;\n    overflow: hidden;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    position: relative;\n    color: #fffffff2;\n}\n\n.dashboard_mid_s.space_gap_0 .trade_movers_tb ul.nav-tabs-check {\n    border-bottom-color: #ffffff12;\n}\n\n.dashboard_mid_s.space_gap_0 .trade_movers_tb button.nav-link-check {\n    font-size: 13px;\n    color: #ffffffd1;\n    padding: 9px 15px;\n}\n\n.dashboard_mid_s.space_gap_0 .order_trade_s .table-trade {\n    padding: 0px 10px;\n}\n\n.dashboard_mid_s.space_gap_0 .relative_select_right {\n    background-color: transparent;\n}\n\n\n.dashboard_mid_s .order_trade_s .table_info_data table tr th {\n    padding: 3px 0px !important;\n    font-size: 12px;\n    font-weight: 300;\n    color: #87909F;\n    position: sticky;\n    top: 0;\n    z-index: 5;\n    background-color: #181a20 !important;\n}\n\n.dashboard_mid_s .order_trade_s .table_info_data table tr td {\n    font-size: 12px;\n    padding: 3px 0px !important;\n    font-weight: 200;\n}\n\n.dashboard_mid_s.space_gap_0 .trade_movers_tb button.nav-link-check.active {\n    background-color: #1b1b1b00;\n    color: #01BC8D;\n}\n\n.order_trade_s .buy_sell_row {\n    border-bottom: none;\n    margin-bottom: 0px;\n    padding: 10px 0px 0px;\n}\n\n/* Order Book / Recent Trades tabs - active state without reload */\n.order_trade_s .trade_movers_tb ul.nav-tabs .nav-item .nav-link {\n    color: #949AA4;\n    border: none;\n    border-bottom: 2px solid transparent;\n    background: transparent;\n}\n\n.order_trade_s .trade_movers_tb ul.nav-tabs .nav-item.active .nav-link,\n.order_trade_s .trade_movers_tb ul.nav-tabs .nav-item .nav-link.active {\n    color: #fff;\n    border-bottom-color: #fff !important;\n    font-weight: 500;\n}\n\n.top_hd_s {\n    background-color: #121212;\n    border-radius: 8px 8px 0px 0px;\n    padding-right: 20px;\n    position: relative;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.order_book_info {\n    width: 100%;\n}\n\n.toggle_dotted {\n    width: 10px;\n    cursor: pointer;\n}\n\n.orderbook_lightbox .form-check {\n    font-size: 14px;\n}\n\n.orderbook_lightbox {\n    color: #fff;\n}\n\n.orderbook_lightbox {\n    width: 250px;\n    display: none;\n    position: absolute;\n    top: 30px;\n    right: 0px;\n    z-index: 666;\n    background-color: #3c3c3c;\n    padding: 24px;\n    border-radius: 10px;\n    border: 1px solid #494949;\n}\n\n.orderbook_lightbox.active {\n    display: block;\n}\n\n.orderbook_lightbox h6 {\n    font-size: 13px;\n    font-weight: 400;\n    padding-bottom: 10px;\n}\n\n.orderbook_lightbox .d-flex.gap-3 {\n    flex-direction: column;\n}\n\n.top_hd_s h2 {\n    font-size: 15px;\n    margin: 0px;\n    background-color: #1B1B1B;\n    padding: 6px 15px;\n    font-weight: 400;\n}\n\n.order_top_table_grid {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 10px 10px 0px;\n}\n\n.order_top_table_grid ul.togglebtn {\n    display: flex;\n    gap: 12px;\n}\n\n.order_top_table_grid ul.togglebtn li {\n    border: 1px solid #3B3B3B;\n    border-radius: 3px;\n    display: flex;\n    padding: 1px 3px;\n    align-items: center;\n    justify-content: center;\n}\n\n.order_right_toggle ul {\n    display: flex;\n    gap: 15px;\n}\n\n.order_right_toggle ul li {\n    font-size: 12px;\n    color: #787878;\n}\n\n.table_info_data table {\n    font-size: 12px;\n    width: 100%;\n}\n\n.table_info_data table tr th {\n    padding: 4px 10px;\n    color: #636363;\n    font-weight: 400;\n}\n\n.table_info_data table tr td {\n    padding: 5px 10px;\n    color: #e9e9e9;\n}\n\n.table_info_data table tr td.danger {\n    color: #F65454;\n}\n\n.table_info_data table tr.totaltb td.danger {\n    font-size: 18px;\n}\n\n.table_info_data table tr.totaltb td.sucess {\n    font-size: 18px;\n}\n\n.table_info_data table tr .subtotal {\n    text-align: center;\n    color: #999;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.table_info_data table tr td.sucess {\n    color: #01BC8D;\n}\n\n.table_info_data table tr .subtotal span {\n    border: 2px solid #3B3B3B;\n    border-radius: 3px;\n    margin-right: 5px;\n    font-weight: 700;\n    color: #666666;\n    font-size: 10px;\n    padding: 1px 2px;\n    /* align-items: center; */\n    justify-content: center;\n}\n\n.trade_movers_tb ul.nav-tabs-check {\n    gap: 18px;\n}\n\n.currency_popup_s .search_form {\n    display: flex;\n    gap: 0px;\n}\n\n.currency_data_list table tr td p {\n    font-size: 14px;\n}\n\n.trade_movers_tb button.nav-link-check.active {\n    background-color: #1b1b1b29;\n    border: none;\n    color: #fff;\n}\n\n.trade_movers_tb button.nav-link-check {\n    font-size: 14px;\n    margin: 0px;\n    color: #fff;\n    border: none;\n    padding: 6px 0px;\n    font-weight: 400;\n    background-color: transparent;\n}\n\n.trade_movers_tb button.nav-link-check:hover {\n    background-color: transparent !important;\n}\n\n.trade_movers_tb button {\n    background-color: transparent !important;\n}\n\n.trade_movers_tb button.nav-link-check:hover {\n    border: none;\n    outline: none;\n}\n\n.trade_summary_table_lft .tab-content>.tab-pane.show {\n    display: block;\n}\n\n.trade_movers_tb .tab-content>.tab-pane.show {\n    display: block;\n}\n\n.market_spot_form .tab-content>.tab-pane.show {\n    display: block;\n}\n\n.trade_summary_table_lft .nav-tabs-check li.active button.nav-link-check {\n    background-color: #1B1B1B;\n    color: #fff;\n}\n\n.tab-pane.fade.showactive {\n    display: block;\n    opacity: 1;\n}\n\n.modal.currency_popup_s .modal-dialog .modal-content {\n    background-color: #2b313c;\n    border: 1px solid #2b313c;\n    border-radius: 12px;\n}\n\n\n\n.modal.currency_popup_s .currency_data_list table tr td {\n    font-size: 11px;\n    padding: 8px 0px;\n    color: #ffffff;\n}\n\n.modal.currency_popup_s .search_form {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    padding: 0 12px;\n}\n\n.modal.currency_popup_s .bn-tabs_favorites_bl button#usd-tab {\n    color: #fff;\n    background-color: transparent;\n    border: none;\n}\n\n.modal.currency_popup_s .currency_data_list table tr th {\n    font-size: 11px;\n    padding: 11px 0px !important;\n    color: #a7a7a7;\n}\n\n.modal.currency_popup_s .modal-header {\n    border: none !important;\n}\n\n.modal.currency_popup_s .currency_data_list table h6 {\n    font-size: 12px;\n}\n\n.modal.currency_popup_s .currency_data_list table tr td p {\n    font-size: 12px;\n}\n\n.relative_select_right {\n    width: 20%;\n    min-height: 100%;\n    max-height: 640px;\n    overflow: auto;\n    padding: 10px 18px;\n    background-color: #181A20 !important;\n    border: none;\n    border-radius: 0px;\n    position: relative;\n    color: #fffffff2;\n}\n\n.top_cross_dashboard {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 0px;\n}\n\n.copy_icon {\n    max-width: 15px;\n}\n\n.spot_future_ {\n    width: 100%;\n    background-color: #121212;\n    padding: 0px 15px;\n    margin-top: 7px;\n}\n\n.spot_future_ ul {\n    display: flex;\n    gap: 10px;\n}\n\n.spot_future_ ul li a {\n    color: #999;\n    font-size: 13px;\n    text-decoration: none;\n    border-bottom: 1px solid #121212;\n    display: block;\n    padding: 10px 4px;\n    font-weight: 500;\n}\n\n.spot_future_ ul li span {\n    color: #01BC8D;\n    background-color: #102621;\n    padding: 4px;\n    border-radius: 5px;\n}\n\n.spot_future_ ul li.active a {\n    color: #fff;\n    border-bottom: 1px solid #01BC8D;\n}\n\n.leverage_bl {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 0px 10px;\n    gap: 12px;\n}\n\n.leverage_bl>div {\n    background-color: #1B1B1B;\n    border-radius: 8px;\n    width: 80%;\n    gap: 14px;\n    font-size: 12px;\n    font-weight: 500;\n    padding: 8px 20px;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n.leverage_bl .rage_txt {\n    color: #5F5F5F;\n}\n\n.leverage_bl div.plustext {\n    width: auto;\n    padding: 8px 6px;\n}\n\n.market_spot_form {\n    width: 100%;\n    margin-top: 7px;\n}\n\n.market_spot_form .nav-tabs-check {\n    background-color: #121212;\n    border: none;\n    justify-content: start;\n    margin-bottom: 10px;\n}\n\n.market_spot_form .nav-tabs-check li button {\n    border: none;\n    background-color: transparent !important;\n    color: #6C6C6C !important;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 5px 6px !important;\n    border-bottom: 1px solid #111114 !important;\n}\n\n.market_spot_form .nav-tabs-check li button.active {\n    color: #fff !important;\n    color: #fff !important;\n    border-bottom: 1px solid #f3bb2b !important;\n}\n\n.market_spot_form .nav-tabs-check li a {\n    border: none;\n    background-color: transparent !important;\n    color: #6C6C6C !important;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.market_spot_form .nav-tabs-check li a.active {\n    color: #fff !important;\n}\n\n.market_spot_form .nav-tabs-check li .dropdown-menu li a {\n    color: #000 !important;\n}\n\nform.price_info {\n    min-height: 100px;\n    max-height: 100%;\n    /* overflow: scroll; */\n    width: 100%;\n    padding: 0px 0px 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.price_inputbl {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.price_inputbl label {\n    font-size: 12px;\n    color: #6C6C6C;\n    font-weight: 400;\n}\n\n.price_select_option {\n    background-color: transparent;\n    font-size: 12px;\n    border-radius: 50px;\n    gap: 10px;\n    padding: 8px 15px;\n    display: flex;\n    justify-content: space-between;\n    border: 1px solid rgb(255 255 255 / 10%);\n}\n\n.price_inputbl .inputtype {\n    border: none;\n    background-color: transparent;\n    padding-left: 2px;\n    color: #fff;\n    width: 100%;\n    max-width: 100%;\n}\n\n.price_inputbl select {\n    border: none;\n    background-color: transparent;\n    color: #e1e1e1;\n    font-size: 13px;\n    width: 100px;\n}\n\nselect:focus-visible {\n    outline: none;\n}\n\n.price_inputbl label span {\n    color: #ababab;\n}\n\n.price_inputbl ul {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.price_inputbl ul li button {\n    font-size: 12px;\n    border-radius: 3px;\n    width: 100%;\n    text-align: center;\n    background-color: #2A2A2A;\n    color: #ababab;\n    padding: 5px;\n    border: none;\n}\n\n.avail_total_usd {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n}\n\n.tpsl_reduce {\n    flex-direction: column;\n    font-size: 13px;\n    color: #6C6C6C;\n}\n\n.buysell_btn button {\n    padding: 6px 26px;\n    background-color: #01BC8D;\n    border: none;\n    font-size: 13px;\n    font-weight: 500;\n    color: #fff;\n    border-radius: 50px;\n    width: 50%;\n}\n\n.buysell_btn button.sellbtn {\n    background-color: #F65454;\n}\n\n.buy_transferbtn button {\n    font-size: 14px;\n    padding: 7px 26px;\n    border-radius: 50px;\n    border: none;\n}\n\n.costbtc_total h5 {\n    font-size: 12px;\n    color: #767676;\n    margin: 0px;\n}\n\n.costbtc_total h5 span {\n    color: #fff;\n}\n\n.price_inputbl .inputtype:focus-visible {\n    outline: none;\n}\n\n.trade_account_summary_assets {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1px;\n    gap: 4px;\n}\n\n.trade_account_summary_assets {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    background-color: #121212;\n}\n\n.trade_summary_table_lft {\n    width: 100%;\n    max-width: 100%;\n    padding: 10px 0px;\n    background: #181A20;\n    border: none;\n    border-radius: 0px;\n    position: relative;\n    color: #fffffff2;\n    font-family: \"Inter\", sans-serif;\n    margin-bottom: 0px;\n}\n\n.trade-wrapper.spot {\n    font-family: \"Inter\", sans-serif;\n}\n\n.trade_summary_table_lft .nav-tabs-check {\n    border-bottom: 1px solid #282828;\n    gap: 15px;\n}\n\n.trade_summary_table_lft .nav-tabs-check li button {\n    border-radius: 0px;\n    border: none;\n    background-color: transparent;\n    font-size: 13px;\n    font-weight: 400;\n    padding: 5px 10px;\n    color: #9f9f9f;\n}\n\n.trade_summary_table_lft .nav-tabs-check li button.active {\n    background-color: #1B1B1B;\n    color: #fff;\n    /* border-bottom: 1px solid #282828; */\n}\n\n.trade_summary_table_lft .tab-content {\n    min-height: 260px;\n    display: flex;\n    align-items: start;\n    justify-content: center;\n}\n\n.trade_summary_table_lft .tab-content h4 {\n    font-size: 14px;\n    margin: 0px;\n}\n\n.trade_summary_table_lft .table-responsive {\n    display: flex;\n    justify-content: center;\n    align-items: start;\n    width: 100%;\n    min-height: 400px;\n    flex-wrap: wrap;\n}\n\n.order_trade_s .tab-content.mt-2 {\n    height: 89%;\n}\n\n.trade_summary_table_lft p.text-center.no-data.h-100.mb-0.center_b {\n    padding: 0px 0px 0px;\n}\n\n.order_trade_s .favouriteData {\n    padding: 0px;\n}\n\n.assets_right {\n    width: 396px;\n    max-width: 100%;\n    background-color: transparent;\n    padding: 10px 18px;\n    position: relative;\n    color: #fffffff2;\n}\n\n.asset_total_value {\n    padding: 0px;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.asset_total_value h5 {\n    color: #fff;\n    font-weight: 500;\n}\n\n.asset_total_value div {\n    font-size: 12px;\n}\n\n.asset_total_value div h6 {\n    font-size: 12px;\n    margin: 0px;\n    color: #767676;\n}\n\n.danger {\n    color: #F65454;\n}\n\nspan.green {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    color: #01BC8D;\n}\n\n.buy_transferbtn {\n    gap: 8px;\n    margin: 10px 0px 30px;\n}\n\n.buy_transferbtn a {\n    font-size: 12px;\n    background-color: #2B313C;\n    color: #fff;\n    border: none;\n    padding: 7px 18px;\n    width: 100%;\n    border-radius: 50px;\n    text-align: center;\n}\n\n.top_future_right_s ul li img {\n    min-width: 20px;\n}\n\n.futuresflex .assets_right {\n    width: 24.23%;\n}\n\n.search_form {\n    width: 100%;\n    border: 1px solid #c7c7c7;\n    padding: 5px;\n    border-radius: 5px;\n    gap: 10px;\n}\n\n.search_form input {\n    border: none;\n    width: 100%;\n}\n\n.search_form input:focus-visible {\n    outline: none;\n}\n\n.bn-tabs_favorites_bl button.nav-link-check {\n    border: none;\n    padding: 0px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #626262;\n    line-height: 22px;\n}\n\n.bn-tabs_favorites_bl li a {\n    border: none;\n    padding: 0px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #626262;\n    line-height: 22px;\n}\n\n.bn-tabs_favorites_bl li a:focus {\n    border: none;\n}\n\n.bn-tabs_favorites_bl li a:hover {\n    border: none;\n}\n\n.bn-tabs_favorites_bl li a.active {\n    border: none;\n}\n\n.bn-tabs_favorites_bl ul {\n    border: none;\n    margin: 10px 0px;\n}\n\n.modal.currency_popup_s .modal-dialog {\n    max-width: 620px;\n    min-width: 600px;\n}\n\n.currency_data_list {\n    color: #181818;\n}\n\n.currency_data_list table {\n    width: 100%;\n}\n\n.currency_data_list table tr td {\n    font-size: 14px;\n    padding: 8px 0px;\n}\n\n.currency_data_list table tr th {\n    font-size: 14px;\n    padding: 5px 0px;\n    font-weight: 400;\n}\n\n.currency_data_list table h6 {\n    margin: 0px;\n    font-size: 14px;\n}\n\n.currency_data_list table p {\n    margin: 0px;\n}\n\n.cnt_first_t {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.cnt_first_t .icon_currency {\n    display: flex;\n    gap: 5px;\n    align-items: center;\n}\n\n.cnt_first_t .icon_currency img {\n    /* width: 32px; */\n}\n\n.cnt_first_t .icon_currency svg {\n    width: 20px;\n    height: auto;\n}\n\n.no_data_found {\n    width: 100%;\n    display: block;\n    text-align: center;\n    padding: 70px 0px;\n    color: #000;\n}\n\n.no_data_found svg {\n    width: 100px;\n}\n\n.no_data_found svg path {\n    fill: #000;\n}\n\n.top_future_left_s ul li.dropdown ul.dropdown-menu {\n    display: none;\n}\n\n.top_future_left_s ul li.dropdown ul.dropdown-menu.dropdown-menu.show {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    align-items: normal;\n    padding: 10px;\n}\n\n\n.top_tabs_center {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    color: #222;\n    font-size: 13px;\n    font-weight: 500;\n    align-items: center;\n}\n\n.classic_option_top {\n    width: 100%;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    padding: 5px;\n}\n\n.leftbar_classic {\n    width: auto;\n}\n\n.leftbar_classic ul {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n}\n\n.leftbar_classic ul li a {\n    width: 40px;\n    height: 46px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #121212;\n}\n\n.leftbar_classic ul li a:hover {\n    background-color: #2A2310;\n}\n\n.leftbar_classic ul li rect {\n    fill: #fff;\n}\n\n.leftbar_classic ul li.active a {\n    background-color: #2A2310;\n}\n\n.leftbar_classic ul li.active rect {\n    fill: #FEBA00;\n}\n\n.classic_usd_right {\n    width: 100%;\n}\n\n.classic_usd_right ul {\n    display: flex;\n    gap: 40px;\n}\n\n.classic_usd_right ul li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    color: #a2a2a2;\n    gap: 10px;\n    padding: 6px 10px;\n    border-radius: 7px;\n}\n\n.classic_usd_right ul li:first-child {\n    background-color: #444444;\n    color: #fff;\n}\n\n.classic_usd_right ul li .cnt_top_cl h6 {\n    margin: 0px;\n    font-size: 13px;\n}\n\n.classic_usd_right ul li .cnt_top_cl p span {\n    padding-left: 20px;\n}\n\n.classic_usd_right ul li .cnt_top_cl p {\n    margin: 0px;\n    font-size: 14px;\n}\n\n.classic_usd_right ul li img {\n    max-width: 24px;\n}\n\n.classic_grid_dashboard_left {\n    width: 100%;\n}\n\n.classic_favorites_bl {\n    width: 100%;\n    border-top: 1px solid #f3f3f329;\n    margin: 0px;\n}\n\n.topnav_selected .nav-tabs-check {\n    border: none;\n}\n\n.topnav_selected .nav-tabs-check .nav-link-check {\n    padding: 0px;\n    border: none;\n    color: #f3f3f39c;\n    padding: 5px 10px;\n    font-size: 13px;\n}\n\n.topnav_selected .nav-tabs-check .nav-link-check:hover {\n    border: none;\n}\n\n.topnav_selected .nav-tabs-check .nav-link-check.active {\n    background-color: transparent;\n    color: #fff;\n}\n\n.d-flex.topnav_selected {\n    padding: 10px 0px;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.right_top_r {\n    display: flex;\n    gap: 20px;\n    padding-right: 32px;\n    position: relative;\n}\n\n.right_top_r .form-check {\n    font-size: 13px;\n    color: #f3f3f39c;\n    margin: 0px;\n}\n\n.right_top_r .orderbook_lightbox form .d-flex {\n    flex-direction: column;\n}\n\n.displayed_reset {\n    padding: 13px 0px;\n}\n\n.displayed_reset h6 {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.displayed_reset h6 span {\n    color: #f0b90b;\n}\n\n.decimal_text {\n    font-size: 12px;\n    color: #b3b3b3;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.decimal_text p {\n    margin: 0px;\n    font-size: 15px;\n}\n\n.classic_favorites_bl .col-sm-9 .tab-content {\n    border-top: 1px solid #f3f3f329;\n    padding: 0px !important;\n}\n\n.top_barcalls_put_cnt {\n    border-bottom: 1px solid #f3f3f329;\n}\n\n.top_barcalls_put_cnt ul {\n    display: flex;\n    align-items: center;\n    gap: 40px;\n    padding: 15px 0px;\n    justify-content: center;\n}\n\n.top_barcalls_put_cnt ul li {\n    font-size: 13px;\n    color: #c5c5c5;\n}\n\n.top_barcalls_put_cnt ul li strong {\n    color: #fff;\n}\n\n\n.data_option_calls table tr th {\n    font-size: 12px;\n    font-weight: 400;\n    color: #999;\n    padding: 15px;\n    border-bottom: 1px solid #f3f3f329;\n    white-space: nowrap;\n}\n\n.data_option_calls table tr td {\n    font-size: 13px;\n    font-weight: 400;\n    color: #999;\n    padding: 15px;\n    border-bottom: 1px solid #f3f3f329;\n}\n\n.data_option_calls table tr td.text-succes {\n    color: #01BC8D;\n}\n\n.data_option_calls table tr td.danger {\n    color: #F65454;\n}\n\n.top_table_data .mid_data tr td {\n    height: 70px;\n    text-align: center;\n}\n\n.data_option_calls table {\n    width: 100%;\n}\n\n.recent_tables_outer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.tables_calls {\n    width: 100%;\n}\n\n.tables_puts {\n    width: 100%;\n}\n\n.recent_trades_options table {\n    width: 100%;\n    font-size: 13px;\n}\n\n.recent_trades_options table tr th {\n    font-size: 12px;\n    font-weight: 400;\n    color: #999;\n    padding: 15px;\n    border-bottom: 1px solid #494949;\n}\n\n.recent_trades_options table tr td {\n    font-weight: 400;\n    padding: 15px;\n    border-bottom: 1px solid #494949;\n}\n\n#TVFuturesChartContainer iframe {\n    height: 600px !important;\n}\n\n@media (max-width: 480px) {\n\n    #TVFuturesChartContainer,\n    #TVFuturesChartContainer iframe {\n        height: 400px !important;\n    }\n}\n\n.recent_trades_options h6 {\n    font-size: 12px;\n    color: #999;\n    padding: 0px 15px;\n}\n\n.classic_favorites_bl .trade_summary_table_lft .nav-tabs-check li button {\n    padding: 10px;\n}\n\n.classic_favorites_bl .trade_summary_table_lft {\n    width: 100%;\n    overflow: hidden;\n}\n\n.hide_underlying_s {\n    display: flex;\n    justify-content: end;\n    padding-right: 30px;\n    gap: 5px;\n    align-items: center;\n    font-size: 13px;\n    color: #999;\n}\n\n.trade_summary_table_lft .row {\n    align-items: center;\n}\n\n.option_account_right {\n    width: 100%;\n    border-left: 1px solid #f3f3f32b;\n    height: 100%;\n}\n\n.trade_option_bl {\n    width: 100%;\n    margin: 0px;\n    padding: 32px;\n    background-color: #222222;\n    text-align: center;\n}\n\n.classic_favorites_bl>.col-sm-9 {\n    padding: 0px;\n}\n\n.classic_favorites_bl>.col-sm-3 {\n    padding: 0px;\n}\n\n.option_account_right h2 {\n    font-size: 15px;\n}\n\n.trade_option_bl p {\n    font-size: 12px;\n    margin: 0px;\n    max-width: 220px;\n    margin: 5px auto;\n}\n\n.option_block {\n    width: 100%;\n    border-radius: 4px;\n    cursor: pointer;\n    padding: 16px;\n    background-color: #454545;\n}\n\n.option_block span {\n    font-size: 12px;\n}\n\n.youtube_icon {\n    max-width: 50px;\n    margin: 0 auto;\n    margin-top: 13px;\n}\n\n.trade_option_bl .row {\n    padding-top: 20px;\n}\n\n.account_block_s {\n    width: 100%;\n    padding: 24px 32px;\n}\n\n.account_tabs_info {\n    width: 100%;\n    display: block;\n    border-bottom: 1px solid #f3f3f32b;\n    padding-bottom: 20px;\n    margin-top: 20px;\n}\n\n.account_tabs_info h5 {\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.account_tabs_info ul {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 12px;\n    font-size: 12px;\n}\n\n.account_tabs_info .cnt_ac.hide {\n    display: none;\n}\n\n.account_tabs_info ul a {\n    color: #a3a3a3;\n    font-size: 13px;\n}\n\n\n.video_popup .modal-dialog {\n    max-width: 750px;\n}\n\n.video_popup .modal-content {\n    background-color: #242526;\n    border-radius: 24px;\n    padding: 5px 12px;\n}\n\n.video_popup .btn-close {\n    border-radius: 50px !important;\n    background-color: #fff;\n    opacity: 1;\n}\n\n.video_popup .modal-header {\n    border: none;\n}\n\n.easy_option_dashboard {\n    background-color: #121212;\n}\n\n.easy_mode_back {\n    width: 100%;\n    padding-top: 18px;\n}\n\n.easy_mode_back a {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #d9d9d99c;\n}\n\n.easy_mode_back svg {\n    width: 20px;\n}\n\n.prediction_top_s {\n    width: 100%;\n    padding: 55px 0px;\n    text-align: center;\n    color: #D9D9D9;\n}\n\n.prediction_bl {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.prediction_up {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 32px;\n}\n\n.prediction_bl p a {\n    color: #FEBA00;\n}\n\n.prediction_bl p {\n    margin: 0px;\n}\n\n.bn_steps_step {\n    width: 100%;\n    position: relative;\n    margin: 20px 0px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.bn_steps_step::before {\n    width: 100%;\n    height: 5px;\n    position: absolute;\n    content: \"\";\n    background-color: #222222;\n}\n\n.bn_steps_step .number {\n    width: 28px;\n    height: 28px;\n    background-color: #222;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50px;\n    font-size: 14px;\n    font-weight: 500;\n    position: relative;\n}\n\n.prediction_detail {\n    width: 100%;\n    padding: 24px;\n    min-height: 250px;\n    border-radius: 10px;\n    background-color: #222222;\n    color: #fff;\n}\n\n.prediction_detail ul {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 48px;\n    margin-top: 70px;\n}\n\n.prediction_detail ul.nav-tabs-check {\n    margin-top: 28px;\n    border: none;\n    justify-content: start;\n    gap: 20px;\n}\n\n.prediction_detail ul li {\n    cursor: pointer;\n}\n\n.prediction_detail ul.nav-tabs-check li button {\n    padding: 0px;\n    background-color: transparent;\n    border: none;\n    font-size: 14px;\n    color: #D9D9D9;\n    font-weight: 500;\n}\n\n.prediction_detail ul.nav-tabs-check li button.active {\n    background-color: transparent;\n    color: #FEBA00;\n}\n\n.prediction_detail ul.nav-tabs-check li button:focus-visible {\n    box-shadow: none;\n}\n\n.prediction_detail .tab-content .tab-pane {\n    margin-top: 22px;\n}\n\n.trade_summary_table_lft tr th {\n    font-size: 12px;\n    font-weight: 300;\n    color: #999;\n    padding: 8px 15px;\n    white-space: nowrap;\n}\n\n.trade_summary_table_lft tr td {\n    font-size: 12px;\n    font-weight: 300;\n    color: #dfdfdf;\n    padding: 8px 12px;\n}\n\n.trade_summary_table_lft tr td .fulltbl {\n    display: flex;\n    gap: 5px;\n    font-size: 10px;\n}\n\n.trade_summary_table_lft tr td .fulltbl span.subtxt {\n    background-color: #222222;\n    padding: 1px 4px;\n    border-radius: 2px;\n}\n\n.trade_summary_table_lft tr th.yellowcolor {\n    color: #f3bb2b;\n}\n\n.trade_summary_table_lft tr td .mkt {\n    display: flex;\n    flex-wrap: nowrap;\n    white-space: nowrap;\n    gap: 12px;\n    justify-content: space-between;\n}\n\n.trade_summary_table_lft tr td .pnl {\n    border: 1px solid #2c2c2c;\n    padding: 3px 10px;\n    border-radius: 5px;\n}\n\n.trade_summary_table_lft tr td .reverse {\n    background-color: #2c2c2c;\n    padding: 4px 8px;\n    border-radius: 4px;\n    text-align: center;\n}\n\n.trade_summary_table_lft tr td button {\n    background-color: #2c2c2c;\n    border-color: #2c2c2c;\n    padding: 4px 8px;\n    border-radius: 4px;\n    text-align: center;\n    border: none;\n    font-size: 12px !important;\n    color: #dfdfdf;\n    font-weight: 400;\n}\n\n.trade_summary_table_lft tr td .mkt ul {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #f3bb2b;\n}\n\n.trade_summary_table_lft table {\n    width: 100%;\n}\n\n.trade_summary_table_lft .tab-content>.tab-pane {\n    width: 100%;\n}\n\n.trade_summary_table_lft tr td.greencolor {\n    color: green;\n}\n\n.trade_summary_table_lft tr td span.time {\n    display: block;\n}\n\n.trade_summary_table_lft tr td i {\n    color: #999;\n    padding-left: 4px;\n}\n\n.trade_summary_table_lft tr td.yellowcolor {\n    color: #f3bb2b;\n}\n\nul.top_list {\n    display: flex;\n    padding: 6px 10px;\n    gap: 6px;\n}\n\nul.top_list li {\n    font-size: 12px;\n    padding: 4px 8px;\n    cursor: pointer;\n    color: #bfbfbf;\n    border-radius: 4px;\n}\n\nul.top_list li.active {\n    background-color: #1b1b1b;\n}\n\n.fill_cnt {\n    width: 100%;\n    display: block;\n    padding: 40px 0px;\n    color: #d9d9d99c;\n    text-align: center;\n}\n\n.esay_option_table {\n    width: 100%;\n    overflow: hidden;\n    padding: 0px 20px;\n}\n\n.trade_summary_table_lft.esay_option_table h2 {\n    color: #fff;\n    margin: 32px 0px;\n}\n\n.trade_summary_table_lft.esay_option_table .nav-tabs-check {\n    border: none;\n    padding-bottom: 10px;\n}\n\n.top_th_easyop {\n    border-bottom: 1px solid #282828;\n}\n\n.esay_option_table thead {\n    border-bottom: 1px solid #282828;\n}\n\n.notfound_vector {\n    max-width: 190px;\n    margin: 0 auto;\n    margin: 60px auto;\n}\n\n.buy_sell_option {\n    width: 100%;\n    display: block;\n    padding: 40px 0px 70px;\n    color: #fff;\n}\n\n.buy_sell_option h5 {\n    font-size: 20px;\n    font-weight: 400;\n    color: #D9D9D9;\n}\n\n.buy_sell_option .nav-tabs-check {\n    border-bottom: none;\n    margin-top: 32px;\n}\n\n.buy_sell_option .nav-tabs-check li button.nav-link-check {\n    font-size: 16px;\n    color: #848e9c;\n    border-radius: 0px;\n    border: none;\n}\n\n.buy_sell_option .nav-tabs-check li button.nav-link-check.active {\n    background-color: #5f38074d;\n    color: #e4a456;\n}\n\n\n.probability_option .title-container {\n    display: flex;\n    width: 100%;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n.probability_option .extra-button {\n    border-radius: 16px;\n    background-color: rgb(252, 213, 53);\n    color: rgb(24, 26, 32);\n    font-size: 13px;\n    line-height: 16px;\n    padding: 4px 8px;\n    font-weight: 600;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n.probability_option .extra-button svg {\n    margin-left: 4px;\n    width: 15px;\n}\n\n.probability_option .title {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 22px;\n    color: rgb(234, 236, 239);\n}\n\n.probability_option {\n    margin: 0px;\n    min-width: 0px;\n    background-color: rgb(43, 49, 57);\n    padding: 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    flex-basis: 100%;\n    border: 1px solid transparent;\n}\n\n.probability_option ul {\n    display: flex;\n    justify-content: space-between;\n    gap: 5px;\n    flex-direction: column;\n    margin-top: 12px;\n}\n\n.probability_option ul li {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    gap: 12px;\n    color: #969696;\n    align-items: start;\n}\n\n.probability_option ul li .value {\n    font-size: 14px;\n    width: 50%;\n    font-weight: 500;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n}\n\n.probability_option ul li .value:first-child {\n    align-items: start;\n}\n\n.buy_sell_option .tab-content {\n    margin-top: 24px;\n}\n\n.probability_option:hover {\n    border: 1px solid #fcd535;\n}\n\n.prediction_up img.prediction_vector {\n    min-height: 170px;\n}\n\n.algo_orders_outers .nav-tabs-check {\n    border-bottom: none;\n}\n\n.algo_orders_outers .nav-tabs-check li .nav-link-check {\n    font-size: 16px;\n    color: #d9d9d9c9;\n    border: none;\n    border-radius: 0px;\n}\n\n.algo_orders_outers .nav-tabs-check li .nav-link-check.active {\n    background-color: transparent;\n    color: #fff;\n}\n\n.topbar_order {\n    justify-content: space-between;\n    gap: 32px;\n    align-items: center;\n    padding: 7px 20px 7px 0px;\n}\n\n.portal_chat_top {\n    width: 50%;\n}\n\n.portal_chat_top ul {\n    display: flex;\n    justify-content: end;\n    gap: 30px;\n    color: #fff;\n}\n\n.portal_chat_top ul li a {\n    display: flex;\n    gap: 10px;\n    color: #fff;\n    font-size: 16px;\n    align-items: center;\n}\n\n.algo_detail_summary {\n    width: 100%;\n    padding: 24px 15px 15px;\n    color: #fff;\n}\n\n.algo_detail_summary p {\n    color: #d9d9d9c9;\n}\n\n.orders_leftside {\n    width: 100%;\n}\n\n.orders_leftside h2 {\n    font-size: 32px;\n}\n\n.orders_leftside .nav-tabs-check {\n    width: 100%;\n    overflow: hidden;\n    background-color: #222222;\n    border-radius: 10px;\n    margin: 20px 0px;\n}\n\n.orders_leftside .nav-tabs-check li {\n    width: 50%;\n    text-align: center;\n}\n\n.algo_detail_summary .row {\n    margin-top: 24px;\n}\n\n.algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check {\n    width: 100%;\n    padding: 22px 15px;\n    border-radius: 10px;\n    color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n}\n\n.algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check.active {\n    background-color: #25B070;\n}\n\n.algo_orders_outers .orders_leftside .nav-tabs-check li.buytab .nav-link-check img {\n    transform: rotate(-90deg);\n}\n\n\n.amount_info_del {\n    width: 100%;\n    background-color: #222222;\n    border-radius: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n}\n\n.algo_detail_summary_left {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.algo_detail_summary_left h5 {\n    color: #C1C9D5;\n    font-weight: 400;\n    margin: 0px;\n}\n\n.pricebtn button {\n    font-size: 12px;\n    background-color: #FEBA00;\n    border: none;\n    padding: 4px 16px;\n    border-radius: 4px;\n    font-weight: 700;\n}\n\n.pricebtn button.blackbtn {\n    background-color: #000;\n    color: #fff;\n}\n\n.amount_info_del.coloum_reverse {\n    flex-direction: row-reverse;\n}\n\n.price_step {\n    width: 100%;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n}\n\n.price_step::before {\n    width: 100%;\n    position: absolute;\n    left: 0px;\n    content: \"\";\n    background-color: #5A5B5C;\n    height: 5px;\n    top: 38%;\n}\n\n.price_step div {\n    margin-top: 40px;\n    position: relative;\n    font-size: 14px;\n    color: #C1C9D5;\n}\n\n.price_step div button:before {\n    width: 16px;\n    height: 16px;\n    background-color: #5A5B5C;\n    position: absolute;\n    right: 0px;\n    top: -22px;\n    content: \"\";\n}\n\n.placebtn button {\n    width: 100%;\n    background-color: #FEBA00;\n    border: none;\n    border-radius: 8px;\n    padding: 22px 20px;\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.price_step div button {\n    padding: 0px;\n    background-color: transparent;\n    border: none;\n    color: #fff;\n}\n\n.algo_order_right {\n    width: 100%;\n}\n\n.top_right_cnt {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.left_price_summary h2 {\n    font-weight: 400;\n}\n\n.left_price_summary p {\n    color: #47A663;\n    line-height: 15px;\n    margin: 15px 0px 0px;\n    display: block;\n    font-weight: 500;\n}\n\n.left_price_summary p span {\n    margin-left: 8px;\n    background-color: #1E1E1E;\n    border: 1px solid #ffffff1f;\n    padding: 3px 8px;\n    border-radius: 5px;\n    color: #fff;\n}\n\n.morebtn_right button {\n    background-color: #1E1E1E;\n    border: 1px solid #ffffff1f;\n    padding: 9px 16px;\n    border-radius: 5px;\n    color: #fff;\n}\n\n.order_summary_graphchat {\n    width: 100%;\n    margin-top: 40px;\n}\n\n.option_symbol_s {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    margin-top: 30px;\n}\n\n.options_section {\n    width: 100%;\n}\n\n.options_section h6 {\n    font-size: 20px;\n    color: #D9D9D9;\n    font-weight: 400;\n}\n\n.options_section ul {\n    display: flex;\n    gap: 24px;\n    margin-top: 15px;\n}\n\n.options_section ul li button {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    font-size: 20px;\n    color: #494949;\n    border: 1px solid #494949;\n    border-radius: 13px;\n    padding: 12px 16px;\n    font-weight: 600;\n    background-color: transparent;\n}\n\n.options_section ul li button.active {\n    color: #fff;\n}\n\n.strategies_cate ul {\n    justify-content: space-between;\n}\n\n.strategies_cate ul li {\n    width: 100%;\n}\n\n.strategies_cate ul li button {\n    width: 100%;\n}\n\n.spot_trading_block {\n    width: 822px;\n    margin: 0 auto;\n    max-width: 100%;\n}\n\n.d-flex.top_bar_hd {\n    justify-content: space-between;\n    align-items: center;\n}\n\n.d-flex.top_bar_hd h4 {\n    font-size: 24px;\n    font-weight: 400;\n}\n\n.setting_icon button {\n    background-color: transparent;\n    border: none;\n}\n\n\n\n\n\n.option_block a {\n    color: #fff;\n}\n\ntr.green_light {\n    background-color: #1b2a2a;\n}\n\ntr.danger_light {\n    background-color: #2f1e26;\n}\n\n\n\n.section_trading .dropdown {\n    position: relative;\n    display: inline-block;\n    width: 200px;\n}\n\n.section_trading .dropdown-toggle {\n    background-color: #2F2F2F;\n    color: #ffffff;\n    padding: 10px 14px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    border: 1px solid #444;\n}\n\n.section_trading .dropdown-toggle .left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.section_trading .dropdown-toggle img.token-icon {\n    width: 24px;\n    height: 24px;\n}\n\n.section_trading .dropdown-menu {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: #1c1c1c;\n    border-radius: 10px;\n    margin-top: 8px;\n    width: 100%;\n    border: 1px solid #444;\n    z-index: 999;\n}\n\n.section_trading .dropdown-menu .item {\n    padding: 10px 14px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #fff;\n    cursor: pointer;\n}\n\n.section_trading .dropdown-menu .item:hover {\n    background-color: #333;\n}\n\n.section_trading .dropdown-menu img {\n    width: 22px;\n    height: 22px;\n}\n\n.section_trading .dropdown-menu.show {\n    display: block;\n}\n\n.d-flex.justify_currency {\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    font-size: 18px;\n}\n\n.d-flex.justify_currency p {\n    color: #717A8C;\n    margin: 0px;\n}\n\n.section_trading {\n    background-color: #222222;\n    padding: 26px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.section_trading .price {\n    font-size: 26px;\n    color: #717A8C;\n}\n\n.trading_info_bl {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    gap: 12px;\n    margin-top: 20px;\n}\n\n.refresh_cntr {\n    width: 98px;\n    position: absolute;\n    margin: 0 auto;\n    left: 0;\n    right: 0px;\n    top: 33%;\n    transform: translateY(-40%);\n}\n\n.total_balance {\n    font-size: 18px;\n    color: #717A8C;\n    text-align: right;\n}\n\n.request_quote_btn button {\n    font-size: 22px;\n    background-color: #feba008f;\n    width: 100%;\n    border: none;\n    border-radius: 12px;\n    padding: 18px 0px 20px;\n}\n\n.request_quote_btn {\n    margin-top: 10px;\n}\n\n.option_block_outer {\n    width: 100%;\n    color: #fff;\n    padding: 20px 40px;\n}\n\n.option_block_outer h1 {\n    font-size: 32px;\n}\n\n.option_block_process {\n    width: 100%;\n    display: block;\n    padding: 20px 0px;\n    border: 1px solid #575757;\n    border-radius: 35px;\n    padding: 40px;\n    margin-top: 40px;\n}\n\n.option_block_process ul {\n    display: flex;\n    gap: 50px;\n    justify-content: space-between;\n}\n\n.option_block_process ul li span {\n    font-size: 20px;\n    margin-bottom: 10px;\n    display: block;\n}\n\n.option_block_process ul li h2 {\n    font-size: 22px;\n    font-weight: 400;\n}\n\n.option_block_process ul li p {\n    color: #999999;\n    margin: 0px;\n}\n\n.createblock_form {\n    width: 100%;\n    display: block;\n    padding: 115px 0px 40px;\n}\n\n.createblock_form .nav-tabs-check {\n    border: none;\n}\n\n.createblock_form .nav-tabs-check li .nav-link-check {\n    font-size: 18px;\n    color: #C1C9D5;\n    font-weight: 600;\n    border: none;\n    border-radius: 12px;\n}\n\n.createblock_form .nav-tabs-check li .nav-link-check.active {\n    background-color: #222222;\n    color: #fff;\n}\n\n.createblock_form>.tab-content {\n    margin-top: 50px;\n}\n\n.creatblock_left_inquery {\n    width: 100%;\n    overflow: hidden;\n    border-radius: 32px;\n    background-color: #474747;\n}\n\nh5.mobile {\n    padding: 10px 15px 0px;\n    font-size: 18px;\n    display: none;\n}\n\n.createblock_form .creatblock_left_inquery .nav-tabs-check {\n    border: none;\n    justify-content: space-between;\n    flex-direction: row;\n    display: flex;\n    flex-wrap: nowrap;\n}\n\n.createblock_form .creatblock_left_inquery .nav-tabs-check li {\n    width: 100%;\n}\n\n.createblock_form .creatblock_left_inquery .nav-tabs-check li .nav-link-check {\n    width: 100%;\n    font-size: 22px;\n    border-radius: 0px;\n    padding: 20px 15px;\n}\n\n.creatblock_left_inquery .tab-content {\n    padding: 40px;\n}\n\n.creatblock_left_inquery .form_input {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 15px;\n    padding-right: 15px;\n    align-items: center;\n    border: 1px solid #5E5E5E;\n    border-radius: 15px;\n}\n\n.creatblock_left_inquery .form_input input {\n    font-size: 20px;\n    width: 100%;\n    color: #C1C9D5;\n    background-color: transparent;\n    border: none;\n    padding: 15px;\n}\n\n.creatblock_left_inquery .form_input input:focus-visible {\n    outline: none;\n    border: none;\n}\n\n.market_spot_form .cnt_table_two {\n    display: none;\n}\n\n.market_spot_form .cnt_table_two.active {\n    display: block;\n}\n\n.creatblock_left_inquery .form_input select {\n    background-color: transparent;\n    border: none;\n    font-size: 18px;\n    color: #fff;\n}\n\n.creatblock_left_inquery .form_input select option {\n    color: #000;\n}\n\n.creatblock_left_inquery .form_input select:focus-visible {\n    outline: none;\n    border: none;\n}\n\n.creatblock_left_inquery .form_input.fullsize select {\n    padding: 15px;\n    width: 100%;\n    color: #7b7b7b;\n}\n\n.buyform form .row {\n    row-gap: 32px;\n}\n\n.submitbtn button {\n    font-size: 22px;\n    background-color: #caab2e;\n    border-radius: 15px;\n    color: #000;\n    padding: 18px 10px;\n    border: none;\n    width: 100%;\n    font-weight: 600;\n}\n\n.createblock_form .submitbtn {\n    background-color: transparent;\n    padding: 0px;\n    border-radius: 0px;\n}\n\n.markert_overview_right {\n    width: 100%;\n    border: 1px solid #575757;\n    padding: 32px;\n    border-radius: 32px;\n    height: 100%;\n}\n\n.markert_overview_right ul {\n    padding-top: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px\n}\n\n.markert_overview_right ul li {\n    color: #C1C9D5;\n    font-size: 18px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.markert_overview_right ul li:last-child {\n    padding-top: 36px;\n}\n\n.strategies_form {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 10px;\n    font-size: 20px;\n    color: #494949;\n    border: 1px solid #494949;\n    border-radius: 13px;\n    padding: 36px;\n    font-weight: 600;\n    background-color: transparent;\n    width: 600px;\n    margin: 0 auto;\n}\n\n.strategies_form form {\n    width: 100%;\n    margin-top: 12px;\n}\n\n.strategies_form h4 {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    font-size: 18px;\n}\n\n.strategies_form form .op_traders_step {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.search_currency .modal-content {\n    background-color: #222222;\n}\n\n.search_currency .modal-header {\n    border-bottom: none;\n}\n\n.search_currency .search_form {\n    border: 1px solid #474747;\n}\n\n.search_currency .search_form input {\n    background-color: transparent;\n    border: none;\n}\n\n.Currency_list_select {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 24px;\n    max-height: 260px;\n    overflow: auto;\n}\n\n.currency_item {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    gap: 15px;\n}\n\n.text-succes {\n    color: #01BC8D;\n}\n\n.currency_item h5 {\n    font-size: 15px;\n    font-weight: 400;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    margin: 0px;\n}\n\n.search_currency button.btn-close {\n    background-color: #fff;\n    opacity: 1;\n    border-radius: 50px;\n    font-size: 12px;\n    top: -13px;\n    position: relative;\n    right: -4px;\n}\n\n.currency_item h5 span {\n    font-size: 13px;\n}\n\n.currency_item img.token-icon {\n    width: 30px;\n    border-radius: 50px;\n}\n\n.op_traders_step .input_block {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.op_traders_step .input_block label {\n    font-size: 14px;\n    color: #fff;\n    min-width: 100px;\n    color: #c4c4c4;\n}\n\n.op_traders_step .input_block .select_option {\n    width: 100%;\n    background-color: transparent;\n    border: 1px solid #494949;\n    border-radius: 6px;\n    padding: 8px;\n    font-size: 14px;\n}\n\n.mobile_view {\n    display: none;\n}\n\n.input_inserst {\n    width: 100%;\n    background-color: transparent;\n    border: 1px solid #494949;\n    border-radius: 6px;\n    padding: 8px;\n    font-size: 14px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.input_inserst input {\n    background-color: transparent;\n    border: none;\n    width: 80%;\n    color: #999;\n}\n\ninput:focus-visible {\n    outline: none;\n}\n\n.submitbtn {\n    background-color: #fcd535;\n    border: none;\n    font-weight: 600;\n    font-size: 18px;\n    padding: 10px 15px;\n    border-radius: 8px;\n}\n\n\n.toggle_righsidebar {\n    width: 300px;\n    color: #c9c9c9;\n    position: absolute;\n    right: 0px;\n    background-color: #1e2329;\n    border: 1px solid #2b3139;\n    top: 0px;\n    padding: 16px;\n    display: none;\n}\n\n.toggle_righsidebar::before {\n    width: 299px;\n    background-color: #1e2329;\n    position: fixed;\n    content: \"\";\n    height: 100%;\n    bottom: 0px;\n    right: 0;\n}\n\n.toggle_righsidebar.active {\n    display: block;\n}\n\n.top_hd svg {\n    width: 18px;\n}\n\n.closebtn {\n    cursor: pointer;\n}\n\n.top_sidebar_main {\n    position: relative;\n}\n\n.top_hd {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n    justify-content: space-between;\n}\n\n.top_hd .leftcnt {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.top_hd h4 {\n    font-size: 16px;\n    margin: 0px;\n    display: flex;\n    gap: 5px;\n}\n\n.sidebartabs .nav-tabs-check {\n    flex-wrap: nowrap;\n    border: none;\n}\n\n.sidebartabs .nav-tabs-check li {\n    width: 100%;\n}\n\n.sidebartabs .nav-tabs-check .nav-link-check {\n    color: #848e9c;\n    border: none;\n    font-size: 15px;\n    width: 100%;\n    border-radius: 50px;\n    padding: 4px 15px;\n}\n\n.sidebartabs .nav-tabs-check .nav-link-check.active {\n    background-color: #feba00;\n    color: #000;\n    font-weight: 500;\n}\n\n.bn_bubble_content {\n    font-size: 13px;\n    background-color: #feba001a;\n    display: inline-block;\n    padding: 2px 5px;\n    border-radius: 4px;\n    color: #feba00;\n    margin: 5px 0px;\n}\n\n.sidebartabs {\n    margin-top: 12px;\n    font-size: 14px;\n}\n\n.avbl_usdt .d-flex {\n    gap: 5px;\n}\n\n.evenodd_icon svg {\n    width: 20px;\n}\n\n.evenodd_icon svg path {\n    color: #feba00;\n}\n\n.price_stbs .price {\n    display: flex;\n    gap: 5px;\n}\n\n.price_stbs .price svg {\n    width: 18px;\n}\n\n.bn_textField_inp {\n    display: flex;\n    justify-content: space-between;\n    gap: 15px;\n    background-color: #2b3139;\n    border-radius: 7px;\n    margin-top: 10px;\n}\n\n.bn_textField_inp input {\n    width: 90%;\n    background-color: transparent;\n    border: none;\n    padding: 10px;\n    color: #999;\n}\n\n.bn_textField_inp .text_primarytext {\n    padding: 10px;\n}\n\n.tif_ios_cnt {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    border-top: 1px solid #2b3139;\n    padding: 20px 0px;\n    border-bottom: 1px solid #2b3139;\n    margin-top: 20px;\n}\n\n.tif_ios_cnt ul {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.tif_ios_cnt ul li a {\n    gap: 0px;\n    display: flex;\n    color: #c9c9c9;\n}\n\n.tif_ios_cnt ul li select {\n    background-color: transparent;\n    border: none;\n    color: #fff;\n}\n\n.tif_ios_cnt ul li select option {\n    color: #000;\n}\n\nbutton.bn-button.button__buy {\n    background-color: #feba00;\n    border: none;\n    font-size: 16px;\n    font-weight: 500;\n    padding: 10px;\n    border-radius: 10px;\n}\n\n.toggle_righsidebar .account_block_s {\n    padding: 0px;\n}\n\n.toggle_righsidebar .account_tabs_info h5 {\n    font-size: 16px;\n}\n\n.toggle_righsidebar .account_tabs_info ul {\n    font-size: 13px;\n}\n\n.account_tabs_info ul li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 15px;\n    color: #c9c9c9;\n}\n\n.account_hd_div {\n    margin-top: 20px;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    justify-content: space-between;\n}\n\n.account_currency_cate {\n    margin: 10px 0px;\n    overflow: auto;\n}\n\n.account_currency_cate ul {\n    display: flex;\n    gap: 15px;\n    flex-direction: row;\n    flex-wrap: nowrap;\n}\n\n.account_currency_cate ul li a {\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.account_hd_div svg {\n    width: 20px;\n}\n\n.account_hd_div svg path {\n    fill: #feba00;\n}\n\n.account_hd_div h2 {\n    font-size: 18px;\n}\n\n.dotted_toggle {\n    width: 18px;\n    cursor: pointer;\n}\n\n.togglehide_cnt {\n    position: absolute;\n    width: 200px;\n    padding: 15px;\n    background-color: #1e2329;\n    right: 0px;\n    top: 24px;\n    border: 1px solid #9999993d;\n    border-radius: 10px;\n    display: none;\n}\n\n.togglehide_cnt.active {\n    display: flex;\n}\n\n.togglehide_cnt ul {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.togglehide_cnt ul li {\n    align-items: center;\n    gap: 7px;\n    display: flex;\n    font-size: 14px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-dialog {\n    max-width: 450px;\n    min-width: 450px;\n    width: 100%;\n}\n\n.modal.currency_popup_s.crosstabs .modal-content {\n    background: #2a2a2a;\n    border-radius: 20px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-header {\n    border: none;\n    padding-bottom: 0px;\n}\n\n.modal.currency_popup_s .btn-close {\n    background-color: #f3bb2b;\n    font-size: 11px;\n    opacity: 1;\n    border-radius: 50px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body {\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n    color: #ffffffe6;\n    flex-direction: column;\n    align-items: start;\n    text-align: left;\n    padding: 0px 32px 32px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body h4 {\n    font-size: 17px;\n    margin-top: 18px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body h4 sup {\n    font-size: 13px;\n    font-weight: 300;\n    background-color: #0000003b;\n    padding: 4px 8px;\n    border-radius: 5px;\n}\n\n.isolated_checked {\n    border-bottom: 1px solid #9999992e;\n    width: 100%;\n    padding-bottom: 7px;\n    margin: 13px 0px;\n}\n\n.user_identyid {\n    max-width: 120px;\n    margin: 0;\n    margin-bottom: 20px;\n    opacity: 0.7;\n}\n\n.modal.currency_popup_s.crosstabs p {\n    font-size: 14px;\n    line-height: 24px;\n}\n\n.modal.currency_popup_s.crosstabs p.redcolor {\n    color: rgb(209, 55, 55);\n}\n\n.range_value {\n    width: 100%;\n}\n\n.range_valuebox {\n    width: 100%;\n    border: 1px solid #9999993b;\n    display: flex;\n    padding: 10px;\n    border-radius: 8px;\n    justify-content: space-between;\n    gap: 10px;\n    align-items: center;\n}\n\n.range_valuebox input {\n    background-color: transparent;\n    border: none;\n    color: #ffffffcc;\n    font-size: 14px;\n    text-align: center;\n}\n\n.value_selected {\n    position: relative;\n    margin-top: 8px;\n}\n\n/* .value_selected::before {\n    width: 100%;\n    height: 1px;\n    background-color: #ffffff40;\n    content: \"\";\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    transform: translate(-50%, -20%);\n} */\n\n.value_selected ul {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    text-align: center;\n}\n\n.value_selected ul li {\n    font-size: 13px;\n    position: relative;\n    color: #ffffff75;\n    margin: -6px 0px 10px;\n}\n\n.value_selected ul li:first-child {\n    text-align: left;\n}\n\n.value_selected ul li:last-child {\n    text-align: right;\n}\n\n.value_selected ul li:last-child::before {\n    margin-right: 0px;\n}\n\n.value_selected ul li:first-child::before {\n    margin-left: 0px;\n}\n\n.value_selected ul li::before {\n    width: 7px;\n    height: 7px;\n    background-color: #adadad;\n    border-radius: 100%;\n    content: \"\";\n    position: absolute;\n    top: -16px;\n    margin: 0 auto;\n    left: 0px;\n    right: 0px;\n}\n\n.btnsupport {\n    flex-direction: column;\n    width: 100%;\n    gap: 5px;\n}\n\n.btnsupport button {\n    font-size: 16px;\n    padding: 10px 24px;\n    border-radius: 50px;\n    border: none;\n    font-weight: 500;\n    background-color: #f3bb2b;\n}\n\n.btnsupport button.customerbtn {\n    background-color: transparent;\n    border-radius: 0px;\n    color: #f3bb2b;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body.free_rate {\n    align-items: start;\n    text-align: left;\n    padding: 15px 32px 32px;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body.free_rate ul {\n    align-items: start;\n    width: 100%;\n    margin: 10px 0px 24px;\n    flex-direction: column;\n}\n\n.modal.currency_popup_s.crosstabs .modal-body.free_rate ul li {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 16px;\n    width: 100%;\n}\n\n.price_stbs .price a {\n    color: #fff;\n}\n\nbutton.bn-button.button__buy.sellbtn {\n    background-color: #f65454;\n    color: #fff;\n}\n\n.top_table_data {\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    border-bottom: 1px solid #f3f3f329;\n    min-height: 200px;\n    max-height: 500px;\n    overflow: auto;\n}\n\n.recent_tables_outer .tables_calls .table-responsive,\n.recent_tables_outer .tables_puts .table-responsive {\n    min-height: 150px;\n    max-height: 150px;\n    overflow: auto;\n}\n\n::-webkit-scrollbar {\n    width: 10px;\n}\n\n::-webkit-scrollbar-track {\n    background: #1e1e1e;\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: #444;\n    border-radius: 10px;\n    border: 2px solid #1e1e1e;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background-color: #666;\n}\n\n/* * {\n    scrollbar-width: thin;\n    scrollbar-color: #444 #1e1e1e;\n} */\n\n.top_table_data .lefside_data {\n    width: 100%;\n}\n\n.top_table_data .table-responsive {\n    min-height: 100%;\n    max-height: 100%;\n}\n\n.top_table_data .right_data {\n    width: 100%;\n}\n\n.top_table_data .mid_data {\n    min-width: 140px;\n    text-align: center;\n}\n\n.topnav_selected .form-check-label:before {\n    display: none;\n}\n\n.data_option_calls table tr td span {\n    display: block;\n    color: #999;\n}\n\n.option_block_outer .esay_option_table {\n    padding: 0px;\n}\n\n@media screen and (max-width:1550px) {\n\n    .top_future_left_s ul {\n        gap: 15px;\n    }\n\n    .top_bar_usd_future {\n        /* overflow: auto; */\n    }\n\n}\n\n\n@media screen and (max-width:1440px) {\n    .data_option_calls table tr th {\n        white-space: nowrap;\n    }\n\n    .recent_trades_options table tr th {\n        white-space: nowrap;\n    }\n\n\n    .algo_orders_outers .nav-tabs-check {\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: auto;\n    }\n\n    .placebtn button {\n        padding: 16px 20px;\n        font-size: 20px;\n    }\n\n    .algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check {\n        padding: 18px 15px;\n    }\n\n    .request_quote_btn button {\n        font-size: 18px;\n        padding: 16px 0px 20px;\n    }\n\n    .crypto_section .hot_trading_s.top_gainers th,\n    td {\n        font-size: 12px;\n    }\n\n}\n\n@media screen and (max-width:1200px) {\n\n    .usd_left_pr {\n        width: 100%;\n    }\n\n\n    .futuresflex .assets_right {\n        width: 100%;\n    }\n\n    .trade_option_bl {\n        padding: 20px;\n    }\n\n    .top_barcalls_put_cnt ul li {\n        font-size: 12px;\n    }\n\n    .top_future_left_s {\n        width: 70%;\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n    .price_info .buysell_btn {\n        flex-direction: column;\n    }\n\n    .price_info .buysell_btn button {\n        width: 100%;\n    }\n\n    .trade_movers_tb ul.nav-tabs-check {\n        gap: 10px;\n    }\n\n    .trade_movers_tb button.nav-link-check {\n        font-size: 12px;\n    }\n\n    .submitbtn button {\n        font-size: 18px;\n        padding: 15px 10px;\n    }\n\n    .createblock_form .creatblock_left_inquery .nav-tabs-check li .nav-link-check {\n        font-size: 18px;\n        padding: 15px 15px;\n    }\n\n    .markert_overview_right h3 {\n        font-size: 20px;\n    }\n\n    .markert_overview_right {\n        padding: 24px;\n    }\n\n    .creatblock_left_inquery .form_input select {\n        font-size: 15px;\n    }\n\n    .creatblock_left_inquery .form_input input {\n        font-size: 15px;\n    }\n\n    .createblock_form {\n        padding: 70px 0px 40px;\n    }\n\n    .trade_summary_table_lft .nav-tabs-check {\n        gap: 5px;\n        overflow: scroll;\n        white-space: nowrap;\n        flex-wrap: nowrap;\n    }\n\n    .algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check {\n        padding: 16px 15px;\n    }\n\n    .h1,\n    h1 {\n        font-size: 30px;\n    }\n\n    .orders_leftside h2 {\n        font-size: 24px;\n    }\n\n    .options_section ul li button {\n        font-size: 15px;\n        border-radius: 10px;\n    }\n\n    .strategies_cate ul {\n        white-space: nowrap;\n        overflow: auto;\n    }\n\n    .request_quote_btn button {\n        font-size: 18px;\n        padding: 15px 0px 20px;\n    }\n\n    .placebtn button {\n        padding: 18px 20px;\n        font-size: 18px;\n    }\n\n    .algo_detail_summary_left h5 {\n        font-size: 16px;\n    }\n\n    .portal_chat_top ul {\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: scroll;\n    }\n\n\n    .top_future_right_s {\n        overflow: auto;\n        width: 35%;\n        white-space: nowrap;\n    }\n\n    .top_bar_usd_future {\n        align-items: end;\n    }\n\n    .trade_summary_table_lft.esay_option_table .nav-tabs-check {\n        flex-wrap: nowrap;\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n    .classic_usd_right ul {\n        overflow: scroll;\n        gap: 20px;\n    }\n\n    .classic_option_top {\n        overflow: hidden;\n    }\n\n\n    .trade_account_summary_assets {\n        flex-direction: column;\n    }\n\n    .trade_summary_table_lft {\n        width: 100%;\n    }\n\n    .assets_right {\n        width: 100%;\n    }\n\n    body .crypto_section .hot_trading_s.top_gainers th,\n    td {\n        font-size: 12px;\n    }\n\n}\n\n\n@media screen and (max-width:991px) {\n\n    .dashboard_mid_s .dashboard_summary_lft {\n        width: 100%;\n    }\n\n    .price_info .buysell_btn {\n        flex-direction: row;\n    }\n\n\n    .trade_summary_table_lft p.text-center.no-data.h-100.mb-0.center_b {\n        padding: 10px 0px 0px;\n    }\n\n    .option_block_process {\n        border-radius: 24px;\n        padding: 24px;\n        margin-top: 24px;\n    }\n\n    .markert_overview_right ul li {\n        font-size: 15px;\n    }\n\n    .row.classic_favorites_bl {\n        flex-direction: column;\n    }\n\n    .row.classic_favorites_bl .col-sm-9 {\n        width: 100%;\n    }\n\n    .row.classic_favorites_bl .col-sm-3 {\n        width: 100%;\n    }\n\n    .recent_tables_outer {\n        flex-direction: column;\n    }\n\n    .dashboard_mid_s {\n        flex-direction: column;\n    }\n\n    .algo_detail_summary .row {\n        flex-direction: column;\n    }\n\n    .algo_detail_summary .row .col-sm-4 {\n        width: 100%;\n    }\n\n    .algo_detail_summary .row .col-sm-8 {\n        width: 100%;\n    }\n\n    .topbar_order {\n        align-items: start;\n        flex-direction: column;\n        gap: 15px;\n    }\n\n    .portal_chat_top ul {\n        justify-content: center;\n    }\n\n    .algo_order_right {\n        margin-top: 30px;\n    }\n\n    .algo_orders_outers .nav-tabs-check {\n        width: 100%;\n    }\n\n    .portal_chat_top {\n        width: 100%;\n    }\n\n    .dashboard_mid_s.space_gap_0 .order_trade_s {\n        width: 100%;\n    }\n\n    .relative_select_right {\n        width: 100%;\n        padding-top: 15px;\n    }\n\n    .table_info_data table tr .subtotal {\n        text-align: left;\n    }\n\n\n    .relative_select_right_mobile_tabs.d-lg-none {\n        display: none;\n    }\n\n\n\n\n    .market_spot_form {\n        padding-bottom: 24px;\n    }\n\n    .trade_summary_table_lft .tab-content {\n        min-height: 100px;\n    }\n\n    .prediction_detail ul.nav-tabs-check {\n        margin-top: 18px;\n        gap: 12px;\n    }\n\n    .trade_summary_table_lft tr td button {\n        white-space: nowrap;\n    }\n\n    .top_future_right_s {\n        padding-bottom: 8px;\n    }\n\n    .top_future_left_s {\n        padding-bottom: 8px;\n    }\n\n}\n\n\n/* 991px tak: relative_select_right sirf Buy/Sell click par show (mobile jaisa) */\n@media screen and (max-width: 991px) {\n\n    .relative_select_right {\n        display: none !important;\n    }\n\n    .relative_select_right.mobile_order_panel_open,\n    .dashboard_mid_s .relative_select_right.mobile_order_panel_open,\n    .space_gap_0 .relative_select_right.mobile_order_panel_open {\n        display: block !important;\n        position: fixed !important;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 80vh !important;\n        max-height: 80vh !important;\n        min-height: 0 !important;\n        z-index: 1055;\n        overflow-y: auto !important;\n        overflow-x: hidden;\n        background: var(--body-bg, #0d0d14);\n        padding: 56px 15px 20px;\n        width: 100%;\n        box-sizing: border-box;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .relative_select_right_mobile_close {\n        display: flex !important;\n        position: absolute;\n        top: 12px;\n        right: 12px;\n        z-index: 1060;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background-color: #f3bb2b;\n        border: none;\n        /* background: none; */\n        color: #181a20;\n        align-items: center;\n        justify-content: center;\n        font-size: 20px;\n        font-weight: 200;\n        cursor: pointer;\n        padding: 0;\n    }\n\n    .relative_select_right_mobile_tabs {\n        display: flex;\n        gap: 0;\n        margin-bottom: 16px;\n        border-bottom: 1px solid #2a2a3a;\n    }\n\n    .relative_select_right_mobile_tabs button {\n        flex: 1;\n        padding: 12px 16px;\n        border: none;\n        background: transparent;\n        color: #888;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        border-bottom: 2px solid transparent;\n        margin-bottom: -1px;\n    }\n\n    .relative_select_right_mobile_tabs button.active {\n        color: #fff;\n    }\n\n    .relative_select_right_mobile_tabs button:first-child.active {\n        border-bottom-color: #22c55e;\n    }\n\n    .relative_select_right_mobile_tabs button:last-child.active {\n        border-bottom-color: #ef4444;\n    }\n\n    .relative_select_right_mobile_backdrop {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0, 0, 0, 0.5);\n        z-index: 1050;\n    }\n}\n\n\n@media screen and (max-width:767px) {\n\n    .dashboard_mid_s .order_trade_s {\n        display: none !important;\n    }\n\n    .modal.currency_popup_s.futures_usd_modal .modal-header {\n        padding: 14px 15px;\n    }\n\n    .modal.currency_popup_s.futures_usd_modal .modal-body {\n        padding: 0px;\n    }\n\n    .modal.currency_popup_s.futures_usd_modal .currency_data_list table tr td {\n        padding: 5px 7px;\n    }\n\n    .modal.currency_popup_s.futures_usd_modal .currency_data_list table tr th {\n        padding: 5px 7px !important;\n    }\n\n    .modal.currency_popup_s.futures_usd_modal .currency_data_list {\n        margin-top: 12px;\n    }\n\n    table tr .lastchild {\n        text-align: right;\n    }\n\n    .search_form_container {\n        padding: 0px 10px;\n    }\n\n    .modal.currency_popup_s.futures_usd_modal .modal-dialog .modal-content {\n        border-radius: 10px 10px 0px 0px;\n    }\n\n    .modal.currency_popup_s.futures_usd_modal .tab-content>.tab-pane {\n        padding-right: 0px;\n    }\n\n    .modal.currency_popup_s.futures_usd_modal h4 {\n        font-size: 15px;\n        margin: 0px;\n    }\n\n    .future_data_mobile>div {\n        min-height: auto !important;\n        /* height: auto !important; */\n    }\n\n    .assets_right {\n        display: none !important;\n    }\n\n    .relative_select_right {\n        display: none !important;\n    }\n\n    .relative_select_right.mobile_order_panel_open,\n    .dashboard_mid_s .relative_select_right.mobile_order_panel_open,\n    .space_gap_0 .relative_select_right.mobile_order_panel_open {\n        display: block !important;\n        position: fixed !important;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 70vh !important;\n        max-height: 70vh !important;\n        min-height: 0 !important;\n        z-index: 999999;\n        overflow-y: auto !important;\n        overflow-x: hidden;\n        background: var(--body-bg, #0d0d14);\n        padding: 20px 15px 20px;\n        width: 100%;\n        box-sizing: border-box;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .relative_select_right_mobile_close {\n        top: 5px;\n        right: 10px;\n    }\n\n    .price_inputbl.value_choose {\n        padding-top: 10px;\n    }\n\n    .price_inputbl ul li button {\n        font-size: 11px;\n    }\n\n    .relative_select_right_mobile_tabs {\n        display: none;\n        gap: 0;\n        margin-bottom: 16px;\n        border-bottom: 1px solid #2a2a3a;\n    }\n\n    .relative_select_right_mobile_tabs button {\n        flex: 1;\n        padding: 12px 16px;\n        border: none;\n        background: transparent;\n        color: #888;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        border-bottom: 2px solid transparent;\n        margin-bottom: -1px;\n    }\n\n    .relative_select_right_mobile_tabs button.active {\n        color: #fff;\n    }\n\n    .relative_select_right_mobile_tabs button:first-child.active {\n        border-bottom-color: #22c55e;\n    }\n\n    .relative_select_right_mobile_tabs button:last-child.active {\n        border-bottom-color: #ef4444;\n    }\n\n    .relative_select_right_mobile_backdrop {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0, 0, 0, 0.5);\n        z-index: 1050;\n    }\n\n    #TVFuturesChartContainer iframe {\n        /* height: 600px !important; */\n    }\n\n    .modal.currency_popup_s .modal-dialog .modal-content {\n        border-radius: 0px;\n    }\n\n    body .modal.currency_popup_s .modal-dialog {\n        min-width: 100%;\n    }\n\n    .buysell_btn button {\n        padding: 5px 24px;\n        font-size: 12px;\n    }\n\n    .trade_account_summary_assets {\n        flex-direction: column-reverse;\n    }\n\n    .price_info .buysell_btn {\n        flex-direction: row;\n    }\n\n    .trade_summary_table_lft .table-responsive {\n        align-items: start;\n        min-height: 260px;\n        max-height: 270px;\n        display: block;\n    }\n\n    .price_select_option {\n        font-size: 12px;\n    }\n\n    .price_inputbl select {\n        font-size: 12px;\n    }\n\n    .trade_summary_table_lft tr td {\n        padding: 7px;\n    }\n\n    .trade_summary_table_lft .nav-tabs-check li button {\n        font-size: 12px;\n    }\n\n    .currency_data_list table h6 {\n        font-size: 12px;\n    }\n\n    .currency_data_list table tr td p {\n        font-size: 12px;\n    }\n\n    .range_valuebox input {\n        width: 100px;\n        font-size: 12px;\n    }\n\n    .buy_transferbtn button {\n        font-size: 12px;\n        padding: 5px 22px;\n    }\n\n    .modal.currency_popup_s.crosstabs .modal-body {\n        padding: 0px 20px 20px;\n    }\n\n    .modal.currency_popup_s.crosstabs .modal-body h4 {\n        font-size: 13px;\n        margin-top: 14px;\n    }\n\n    .modal.currency_popup_s.crosstabs .modal-body h4 sup {\n        font-size: 10px;\n    }\n\n    .modal.currency_popup_s.crosstabs .modal-body h3 {\n        font-size: 18px;\n    }\n\n    .modal.currency_popup_s.crosstabs p {\n        font-size: 12px;\n        margin-bottom: 10px;\n    }\n\n    .btnsupport button {\n        font-size: 12px;\n        padding: 6px 24px;\n    }\n\n    .option_block_process ul {\n        gap: 24px;\n        flex-direction: column;\n    }\n\n    .createblock_form {\n        padding: 40px 0px 20px;\n    }\n\n    .createblock_form .nav-tabs-check li .nav-link-check {\n        font-size: 14px;\n    }\n\n    .option_block_process ul li h2 {\n        font-size: 18px;\n    }\n\n    .algo_detail_summary p {\n        margin-bottom: 0px;\n    }\n\n    .option_block_outer h1 {\n        font-size: 24px;\n    }\n\n    .top_table_data .mid_data.mobile_view {\n        display: flex;\n        min-width: auto;\n    }\n\n    .top_table_data .right_data {\n        display: flex;\n    }\n\n    h5.mobile {\n        display: block;\n    }\n\n    .top_table_data {\n        max-height: 100%;\n    }\n\n    .top_table_data .mid_data {\n        min-width: 100%;\n        padding: 0px 0px;\n    }\n\n    .top_table_data .mid_data tr td {\n        height: 47px;\n    }\n\n    .top_table_data .lefside_data {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n    }\n\n    .recent_trades_options h6 {\n        padding: 0px 0px;\n    }\n\n    h5.mobile {\n        padding: 10px 0px 0px;\n        font-size: 16px;\n    }\n\n    .recent_tables_outer {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .recent_tables_outer .tables_calls .table-responsive,\n    .recent_tables_outer .tables_puts .table-responsive {\n        min-height: 250px;\n        max-height: 250px;\n    }\n\n    .data_option_calls table tr td {\n        font-size: 12px;\n        padding: 8px;\n    }\n\n    .recent_trades_options table tr th {\n        white-space: nowrap;\n    }\n\n    .top_table_data {\n        flex-direction: column;\n    }\n\n    .top_barcalls_put_cnt ul {\n        gap: 20px;\n        padding: 10px 20px;\n    }\n\n    .container,\n    .container-sm {\n        max-width: 90%;\n    }\n\n    .d-flex.topnav_selected {\n        flex-direction: column;\n    }\n\n    .topnav_selected .nav-tabs-check {\n        width: 100%;\n    }\n\n    .right_top_r {\n        padding: 0px 13px;\n        width: 100%;\n    }\n\n    .orderbook_lightbox {\n        right: inherit;\n        padding: 18px;\n    }\n\n    .data_option_calls table tr th {\n        white-space: nowrap;\n        padding: 10px 15px;\n        font-size: 12px;\n    }\n\n    .classic_usd_right ul li .cnt_top_cl h6 {\n        font-size: 12px;\n    }\n\n    .classic_usd_right ul li .cnt_top_cl p {\n        font-size: 12px;\n    }\n\n    .trade_option_bl {\n        padding: 18px;\n    }\n\n    .account_block_s {\n        padding: 18px;\n    }\n\n    .account_currency_cate ul li a {\n        font-size: 12px;\n    }\n\n    .recent_trades_options table tr td {\n        padding: 10px 15px;\n        font-size: 12px;\n    }\n\n    .portal_chat_top {\n        padding: 0px 20px;\n    }\n\n    .top_barcalls_put_cnt ul {\n        white-space: nowrap;\n        overflow: scroll;\n        justify-content: space-around;\n    }\n\n    .h1,\n    h1 {\n        font-size: 24px;\n    }\n\n    h2 {\n        font-size: 20px;\n    }\n\n    .orders_leftside h2 {\n        font-size: 20px;\n    }\n\n    .algo_orders_outers .orders_leftside .nav-tabs-check li .nav-link-check {\n        padding: 11px 12px;\n        font-size: 14px;\n    }\n\n    .morebtn_right button {\n        padding: 6px 16px;\n    }\n\n    .algo_detail_summary_left h5 {\n        font-size: 14px;\n    }\n\n    .options_section ul {\n        gap: 15px;\n        margin-top: 15px;\n        overflow: scroll;\n    }\n\n    .strategies_form {\n        font-size: 18px;\n        padding: 24px;\n        width: 100%;\n    }\n\n    .placebtn button {\n        padding: 12px 20px;\n        font-size: 16px;\n    }\n\n    .algo_orders_outers .nav-tabs-check li .nav-link-check {\n        font-size: 14px;\n    }\n\n    .portal_chat_top ul li a {\n        font-size: 14px;\n    }\n\n    .section_trading .dropdown-toggle {\n        padding: 7px 14px;\n        font-size: 15px;\n    }\n\n    .section_trading .price {\n        font-size: 18px;\n    }\n\n    .options_section ul li button {\n        font-size: 14px;\n    }\n\n    .d-flex.justify_currency {\n        font-size: 15px;\n    }\n\n    .request_quote_btn button {\n        font-size: 15px;\n        padding: 13px 0px 13px;\n    }\n\n    .refresh_cntr {\n        width: 42px;\n    }\n\n    .total_balance {\n        font-size: 14px;\n    }\n\n    span.green {\n        font-size: 15px;\n    }\n\n    .d-flex.top_bar_hd h4 {\n        font-size: 20px;\n    }\n\n    .submitbtn {\n        font-size: 15px;\n        padding: 8px 15px;\n    }\n\n    .trade_summary_table_lft.esay_option_table h2 {\n        margin: 15px 0px;\n    }\n\n    .portal_chat_top ul {\n        justify-content: start;\n    }\n\n    .portal_chat_top ul li {\n        font-size: 13px;\n    }\n\n    .row.prediction_row {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .prediction_detail {\n        min-height: 100%;\n    }\n\n    .prediction_detail ul {\n        gap: 32px;\n        margin-top: 30px;\n    }\n\n    .fill_cnt {\n        padding: 20px 0px 0px;\n    }\n\n    .row.prediction_row .col-sm-4 {\n        width: 100%;\n    }\n\n    .prediction_top_s {\n        padding: 20px 0px;\n    }\n\n    .buy_sell_option {\n        padding: 30px 0px 40px;\n    }\n\n    .buy_sell_option .row {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .buy_sell_option .row .col-sm-4 {\n        width: 100%;\n    }\n\n    button.bn-button.button__buy {\n        font-size: 14px;\n        padding: 7px 10px;\n        border-radius: 6px;\n    }\n\n    .search_form .modal-body {\n        padding: 24px !important;\n    }\n\n    .trade_summary_table_lft .tab-content {\n        min-height: 60px;\n    }\n\n    .trade_summary_table_lft .nav-tabs-check {\n        gap: 5px;\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: auto;\n    }\n\n    .price_top_right {\n        font-size: 14px;\n    }\n\n    .price_top_right span {\n        font-size: 12px;\n    }\n\n    .prediction_detail ul li img {\n        width: 42px;\n    }\n\n    body {\n        font-size: 14px;\n    }\n\n    .prediction_detail ul.nav-tabs-check {\n        flex-wrap: nowrap;\n        white-space: nowrap;\n        overflow: scroll;\n    }\n\n    .buy_sell_option .nav-tabs-check li button.nav-link-check {\n        font-size: 14px;\n        padding: 5px 10px;\n    }\n\n    .buy_sell_option .nav-tabs-check {\n        margin-top: 18px;\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: scroll;\n    }\n\n    .trade_summary_table_lft tr th {\n        padding: 6px 15px;\n        white-space: nowrap;\n    }\n\n    .account_hd_div {\n        margin-top: 0px;\n    }\n\n    .createblock_form>.tab-content {\n        margin-top: 20px;\n    }\n\n    .createblock_form .creatblock_left_inquery .nav-tabs-check li .nav-link-check {\n        font-size: 15px;\n        padding: 12px;\n    }\n\n    .creatblock_left_inquery .tab-content {\n        padding: 24px;\n    }\n\n    .buyform form .row {\n        row-gap: 20px;\n    }\n\n    .creatblock_left_inquery .form_input input {\n        font-size: 14px;\n        padding: 10px 15px;\n    }\n\n    .creatblock_left_inquery .form_input.fullsize select {\n        padding: 10px 15px;\n    }\n\n    .submitbtn button {\n        font-size: 15px;\n        padding: 12px 10px;\n    }\n\n    .createblock_form .row {\n        gap: 24px;\n    }\n\n    .markert_overview_right ul {\n        padding-top: 15px;\n        gap: 15px;\n    }\n\n    .notfound_vector {\n        max-width: 120px;\n        margin: 30px auto;\n    }\n\n    .table_info_data table tr th {\n        font-size: 12px;\n    }\n\n    .table_info_data table tr.totaltb td.danger {\n        font-size: 15px;\n    }\n\n    .trade_movers_tb button.nav-link-check {\n        font-size: 13.5px;\n    }\n\n    .top_cross_dashboard ul li a {\n        padding: 4px 12px 4px;\n        font-size: 12px;\n    }\n\n    .usd_future_dashboard .dashboard_mid_s {\n        gap: 20px;\n    }\n\n    .top_cross_dashboard ul {\n        gap: 10px;\n    }\n\n    .trade_summary_table_lft p.text-center.no-data.h-100.mb-0.center_b {\n        padding: 40px 0px 0px;\n    }\n\n}\n\n@media screen and (max-width:660px) {\n\n    .top_bar_usd_future {\n        align-items: normal;\n        flex-direction: column;\n        gap: 15px;\n    }\n\n\n\n    .modal.currency_popup_s .modal-dialog {\n        max-width: 70%;\n        margin: 20px auto;\n    }\n\n    .topnav_selected .nav-tabs-check .nav-link-check {\n        padding: 4px 7px;\n        font-size: 12px;\n    }\n\n    .top_barcalls_put_cnt ul li {\n        font-size: 12px;\n    }\n\n    .range_valuebox {\n        padding: 5px 10px;\n    }\n\n    .value_selected ul li {\n        font-size: 11px;\n    }\n\n    .price_top_right {\n        font-size: 12px;\n    }\n\n    .top_future_left_s ul li {\n        font-size: 12px;\n    }\n\n    .trade_option_bl .row {\n        gap: 24px;\n    }\n\n    .createblock_form .nav-tabs-check li .nav-link-check {\n        font-size: 13px;\n    }\n\n\n    .currency_popup_s h4 {\n        font-size: 18px;\n    }\n\n    .trade_option_bl .row .col-sm-6 {\n        width: 100%;\n    }\n\n    .modal.currency_popup_s.crosstabs .modal-dialog {\n        max-width: 90%;\n        min-width: 90%;\n        margin: 0 auto;\n    }\n\n    .buy_sell_option h5 {\n        font-size: 18px;\n    }\n\n    .hide_underlying_s {\n        justify-content: start;\n        padding: 10px 10px 0px;\n        margin-bottom: 15px;\n    }\n\n    .top_future_left_s {\n        width: 100%;\n    }\n\n    .top_future_right_s {\n        width: 100%;\n    }\n\n    .trade_summary_table_lft .nav-tabs-check {\n        gap: 5px;\n    }\n\n    .prediction_up img.prediction_vector {\n        min-height: 120px;\n        width: 150px;\n    }\n\n    .prediction_up {\n        gap: 15px;\n    }\n\n    .space_gap_0.dashboard_mid_s .relative_select_right {\n        padding: 28px 15px 15px !important;\n    }\n\n\n}\n\n.text-green {\n    color: #2BC287 !important;\n}\n\n.text-red {\n    color: #E45561 !important;\n}\n\n.table-trade {\n    overflow: clip;\n    height: 210px;\n}\n\n.desktop_view .topnav_selected ul li.active button {\n    border: 1px solid #f3bb2b;\n}\n\n\n.nav-check {\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n    padding: 0px 10px;\n\n}\n\n.market-close {\n    background-color: #2c2c2c !important;\n    border-color: #2c2c2c !important;\n    padding: 4px 8px !important;\n    border-radius: 4px !important;\n    text-align: center !important;\n    border: none !important;\n    font-size: 12px !important;\n    color: #dfdfdf !important;\n    font-weight: 300 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
